import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  OnDestroy,
  HostBinding,
  SimpleChanges,
  ViewChild,
  TemplateRef,
  PipeTransform,
} from "@angular/core";

import { UtilityService } from "@common/services";
import {
  sideNavItemsList,
  sideNavSections,
} from "@modules/navigation/data/side-nav-dashboard.data";
import {
  keyvalue,
  SideNavItem,
  SideNavItems,
  SideNavSection,
} from "@modules/navigation/models";
import { NavigationService } from "@modules/navigation/services";
import { BehaviorSubject, Subscription, timeout } from "rxjs";
import { ApiRequestService } from "@common/services/api-request.service";
import { ToastService } from "@common/services/toast.service";
import { Router, NavigationEnd } from "@angular/router";
import { Buffer } from "buffer";
import { IdelTimeoutService } from "@app/services/idel-timeout.service";
import { DataService } from "../../../../app/services/data.service";
import { SecureStorageService } from "../../../../app/services/secure-storage.service";
import { CookieService } from "ngx-cookie-service";
import { PermissionsService } from "@app/services/permissions.service";
import { NavService } from "app/services/nav.service";
import { environment } from "environments/environment";
import {
  mfaPromptActive$,
  resolveMfaEnabledFromProfile,
  shouldEnforceMfaByEnvironment,
} from "@modules/auth/utils/mfa-policy.util";

@Component({
    selector: "sbpro-layout-dashboard",
    templateUrl: "./layout-dashboard.component.html",
    styleUrls: ["layout-dashboard.component.scss"],
    standalone: false
})
export class LayoutDashboardComponent implements OnInit, OnDestroy {
  @Input() static = false;
  @Input() light = false;
  @Input() rtl = false;
  @Input() activeTab!: string;

  @HostBinding("class.sidenav-toggled") sideNavHidden = false;
  subscription: Subscription = new Subscription();
  sideNavItemsList = sideNavItemsList;
  sideNavSections = sideNavSections;
  sidenavStyle = "sidenav-dark";
  _isDataLoaded: boolean = false;
  companyCheck = localStorage.getItem("company");

  dashboard = "";
  reporting = "";
  users = "";
  notifications = "";
  tariff = "";
  alert = "";
  integration = "";
  formsConfiguration = ""
  jobbox = "";
  diagnostics = "";
  geolocation = "";

  reloadNav = "no";
  impersination = "no";

  deviceManagement = "";
  meteringSectionManagement = "";
  meteringPointManagement = "";
  tariffManagement = "";
  notificationManagement = "";
  reportManagement = "";
  userManagement = "";
  pmLevel = "";
  hasMetersForDiagnostics = false;
  showPendingApprovalsToast = false;
  isChannelPartner = false;
  isSkippingTariffReview = false;
  organisationTariffsLabel: string = 'Account Tariffs';
  pendingApprovalsData: any = null;
  private mfaFlowActive = false;
  private mfaPromptActive = false;
  private mfaFlowStateInitialized = false;
  private mfaPromptStateInitialized = false;
  private pendingApprovalsRequestInFlight = false;

  toggleDeviceSubscription: Subscription;
  unapprovedRegisteredUser: any;
  private navigationLoadSub?: Subscription;
  private latestSearchTerm: string = '';
  isUsersContext: boolean = false;

  constructor(
    private apiRequest: ApiRequestService,
    public utilityService: UtilityService,
    private toastService: ToastService,
    private router: Router,
    public navigationService: NavigationService,
    private changeDetectorRef: ChangeDetectorRef,
    private idelTimeOutService:IdelTimeoutService,
    private dataService:DataService,
    private secureStorage:SecureStorageService,
    private cookieService:CookieService,
    private permissionsService: PermissionsService,
    private navService: NavService,
  ) {
    this.toggleDeviceSubscription = this.dataService.currentMessage.subscribe(message => {
      if(message){
       window.location.reload()
      }
    })
    this.subscription.add(this.dataService.mfaFlowActive.subscribe(active => {
      if (!this.mfaFlowStateInitialized) {
        this.mfaFlowStateInitialized = true;
        this.mfaFlowActive = active;
        return;
      }
      this.mfaFlowActive = active;
      if (active) {
        // A request may have started before MFA became active. Its response
        // must not be allowed to open a tariff modal underneath MFA.
        this.showPendingApprovalsToast = false;
      } else if (localStorage.getItem('userID')) {
        this.checkPendingApprovals();
      }
      this.changeDetectorRef.markForCheck();
    }));
    this.subscription.add(mfaPromptActive$.subscribe(active => {
      // BehaviorSubject emits `false` immediately on subscription. It is not
      // an MFA completion event and must never start a tariff request.
      if (!this.mfaPromptStateInitialized) {
        this.mfaPromptStateInitialized = true;
        this.mfaPromptActive = active;
        return;
      }
      this.mfaPromptActive = active;
      if (active) {
        this.showPendingApprovalsToast = false;
      } else if (!this.mfaFlowActive && localStorage.getItem('userID')) {
        this.checkPendingApprovals();
      }
      this.changeDetectorRef.markForCheck();
    }));
  }
  async ngOnInit() {
    this.loadOrganisationTariffsLabel();
    this.unapprovedRegisteredUser = localStorage.getItem('unapprovedRegisteredUser')

    // Watch route changes to toggle side-nav vs side-nav-search
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateUsersContext(event.urlAfterRedirects || event.url);
      }
    });
       
    this.idelTimeOutService.startTracking()
    if (!localStorage.getItem("userID")) {
      this.router.navigateByUrl("/auth/login");
      return;
    }

    let dataitem: any = [];
    this.reloadNav = "yes";
    sideNavItemsList.AddData(dataitem);
    this.changeDetectorRef.detectChanges();

    this.pmLevel = localStorage.getItem("pmLevel") as string;

    if (this.light) {
      this.sidenavStyle = "sidenav-light";
    }
    this.subscription.add(
      this.navigationService.sideNavVisible$().subscribe((isVisible) => {
        this.sideNavHidden = !isVisible;
        this.changeDetectorRef.markForCheck();
      })
    );

    // Initialize context on first load
    this.updateUsersContext(this.router.url);

    this.dashboard = "";
    this.reporting = "";
    this.users = "";
    this.notifications = "";
    this.tariff = "";
    this.alert = "";
    this.integration = "";
    this.formsConfiguration = "";
    this.jobbox = "";
    this.diagnostics = "";
    this.geolocation = "";

    let permissions:any = this.permissionsService.getAll();
    // let permissions:any = await this.secureStorage.getItem('permissions');
    // permissions =  JSON.parse(permissions);


    this.notificationManagement = permissions.notificationManagement;
    this.tariffManagement = permissions.tariffManagement;
    this.reportManagement = permissions.reportManagement;
    this.userManagement = permissions.userManagement;

    if (this.unapprovedRegisteredUser === 'true') {
      return;
    }

    // Allow child MFA checks to establish their initial state before checking
    // tariff approvals. This also covers refreshes and deep links where no
    // MFA transition is emitted (for example, when MFA was skipped).
    setTimeout(() => {
      const mfaIsEnforced = shouldEnforceMfaByEnvironment(
        environment.environment,
        typeof window !== "undefined" ? window.location.hostname : undefined
      );
      const waitingForMfaDecision =
        mfaIsEnforced &&
        localStorage.getItem("mfaSkipped") !== "true" &&
        localStorage.getItem("impersination") !== "yes";

      if (waitingForMfaDecision) {
        // Some dashboard routes do not perform the MFA profile check. Resolve
        // it here so pending approvals do not wait forever on a child event.
        if (!this.mfaFlowActive && !this.mfaPromptActive) {
          void this.resolveInitialMfaDecision();
        }
        return;
      }

      this.checkPendingApprovals();
    }, 0);
    this.initializeDiagnosticsAccess();
    this.navService.loadStats();
  }

  private async resolveInitialMfaDecision(): Promise<void> {
    await resolveMfaEnabledFromProfile(
      this.apiRequest,
      parseInt(localStorage.getItem("userID") as string, 10)
    );

    if (!this.mfaFlowActive && !this.mfaPromptActive) {
      this.checkPendingApprovals();
    }
  }

  ngAfterViewInit() {
    if (localStorage.getItem("userID")) {
this.activeTab = localStorage.getItem("active") as string;
    setTimeout(() => {
      if (this.activeTab == "dashboard") {
        this.dashboard = "active-item";
    
        //this.searchNavigationMenu();

      } else if (this.activeTab == "reporting") {
        this.reporting = "active-item";
       // this.searchNavigationMenu();
      } else if (this.activeTab == "users") {
        this.users = "active-item";
        this.LoadAccountHeirachy();
      } else if (this.activeTab == "notifications") {
        this.notifications = "active-item";
      // this.searchNavigationMenu();
      } else if (this.activeTab == "tariff") {
        this.tariff = "active-item";
       //  this.searchNavigationMenu();
      } else if (this.activeTab == "alerts") {
        this.alert = "active-item";
       // this.searchNavigationMenu();
      } else if (this.activeTab == "integration") {
        this.integration = "active-item";
       // this.searchNavigationMenu();
      }else if (this.activeTab == "formsConfiguration") {
        this.formsConfiguration = "active-item";
       //  this.searchNavigationMenu();
      } else if (this.activeTab == "diagnostics") {
        this.diagnostics = "active-item";
       //  this.searchNavigationMenu();
      } else if (this.activeTab == "geolocation") {
        this.geolocation = "active-item";
      //  this.searchNavigationMenu();
      } else if (this.activeTab == "jobbox") {
        // this.jobbox = "active-item";
      } else {
        localStorage.setItem("active", "dashboard");
        this.dashboard = "active-item";
       //  this.searchNavigationMenu();
      }
      this.changeDetectorRef.detectChanges();
    }, 1000);
    console.log("activeTab", this.activeTab);
    } 
  }

  private initializeDiagnosticsAccess(): void {
    if (this.unapprovedRegisteredUser === 'true') {
      this.hasMetersForDiagnostics = false;
      return;
    }

    const cachedHasMeters = localStorage.getItem("hasMeters");
    if (cachedHasMeters !== null) {
      this.hasMetersForDiagnostics = cachedHasMeters === "yes";
      this.changeDetectorRef.detectChanges();
    }
    this.loadDiagnosticsAccess();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.activeTab?.firstChange) {
      return;
    }
    this.reloadNav = "no";
    this.changeDetectorRef.detectChanges();

    this.reloadNav = "yes";

    if (localStorage.getItem("impersination") == "yes") {
      this.impersination = "yes";
    }
    this.changeDetectorRef.detectChanges();

    //set active tab
    this.dashboard = "";
    this.reporting = "";
    this.users = "";
    this.notifications = "";
    this.tariff = "";
    this.alert = "";
    this.integration = "";
    this.formsConfiguration = "";
    this.jobbox = "";
    this.diagnostics = "";
    this.geolocation = "";

    setTimeout(() => {
      if (this.activeTab == "dashboard") {
        this.dashboard = "active-item";
      } else if (this.activeTab == "reporting") {
        this.reporting = "active-item";
      } else if (this.activeTab == "users") {
        this.users = "active-item";
      } else if (this.activeTab == "notifications") {
        this.notifications = "active-item";
      } else if (this.activeTab == "tariff") {
        this.tariff = "active-item";
      } else if (this.activeTab == "alerts") {
        this.alert = "active-item";
      } else if (this.activeTab == "integration") {
        this.integration = "active-item";
      } else if (this.activeTab == "formsConfiguration") {
        this.formsConfiguration = "active-item";
      }  else if (this.activeTab == "diagnostics") {
        this.diagnostics = "active-item";
      } else if (this.activeTab == "geolocation") {
        this.geolocation = "active-item";
      } else if (this.activeTab == "jobbox") {
        // this.jobbox = "active-item";
      } else {
        localStorage.setItem("active", "dashboard");
        this.dashboard = "active-item";
      }

      // Sync users context with input changes
      // this.isUsersContext = this.activeTab === 'users' || this.routeIsUsersContext(this.router.url);

      // if (this.activeTab == "users") {
      //   if (localStorage.getItem("reload") == "yes") {
      //     this.getInitialNavigationMenuDataAccounts()
      //   } else {
      //     if (localStorage.getItem("account_hierarchy"))

      //     this.getInitialNavigationMenuDataAccounts()
      //     else {
      //       this.getInitialNavigationMenuDataAccounts()
      //     }
      //   }
      // }
      // else {
      //     if(localStorage.getItem("reload") == "yes"){
      //         this.LoadMeteringHeirachy();
      //     }
      //     else{
      //         this.LoadAccountHeirachyJson();
      //     }
      // }
      // else {
        //  if (localStorage.getItem("userID")) {
        //   this.searchNavigationMenu();
        //  }
        
      // }

      this.changeDetectorRef.detectChanges();
    }, 2000);
    //}
  }

  private loadDiagnosticsAccess(): void {
    const userId = Number(localStorage.getItem("userID"));
    if (!userId) {
      this.hasMetersForDiagnostics = false;
      return;
    }

    const body = {
      payload: {
        userID: userId,
      },
    };

    this.apiRequest
      .apiRequest("metering/navigation/stats", "stats.json", body)
      .subscribe({
        next: (res) => {
          const metersCount = Number(res?.data?.meters) || 0;
          this.hasMetersForDiagnostics = metersCount > 0;
          this.changeDetectorRef.detectChanges();
        },
        error: () => {
          this.hasMetersForDiagnostics = false;
          this.changeDetectorRef.detectChanges();
        },
      });
  }

  private routeIsUsersContext(url: string | undefined): boolean {
    const u = url || '';
    const cleaned = u.replace(/\/+$/, '');
    return cleaned.startsWith('/dashboard/metering/user') || cleaned.startsWith('/dashboard/users');
  }

  private updateUsersContext(url: string | undefined) {
    const isUsersRoute = this.routeIsUsersContext(url);
    this.isUsersContext = isUsersRoute || this.activeTab === 'users';
    if (isUsersRoute) {
      if (localStorage.getItem('active') !== 'users') {
        localStorage.setItem('active', 'users');
      }
      this.users = 'active-item';
    }
    this.changeDetectorRef.markForCheck();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.toggleDeviceSubscription.unsubscribe()
    this.idelTimeOutService.resetTimer()
    if (this.navigationLoadSub) {
      this.navigationLoadSub.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async LoadMeteringHeirachyJson() {

    let permissions:any = this.permissionsService.getAll();
    // let permissions:any = await this.secureStorage.getItem('permissions');
    // permissions =  JSON.parse(permissions);
 

    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

  

     this.apiRequest.apiRequest('metering/metering_hierarchy/', 'metering_hierarchy.json', body)
     .subscribe(data => {
      if (data.success == true) {
        this.sideNavSections[0].items = [];
        if (
          data.data.meteringFarms &&
          data.data.meteringFarms.length > 0 &&
          this.meteringSectionManagement != "no-access"
        ) {
          data.data.meteringFarms.forEach((element: any) => {
            // adding value to parent menu
            let _keyValue: keyvalue = {} as keyvalue;
            _keyValue.key = element.meteringFarmID;
            _keyValue.value = element.meteringFarmName;
            this.sideNavSections[0].items.push(_keyValue);
            let meteringSections: any = [];
  
            if (
              element.meteringSections &&
              element.meteringSections.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              element.meteringSections.forEach(
                (ms_element: any, ms_index: any, ms_array: any[]) => {
                  let meteringPoints: any = [];
  
                  //Add for each metering section
                  let meteringPoint = {
                    type: "modems",
                    icon: "",
                    userAccount: "yes",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/modems.png"
                        : "assets/dashboard/menu/modem.png",
                    text: "Modems/Gateways",
                    key: ms_element.meteringSectionID,
                    level: "modems",
                  };
                  meteringPoints.push(meteringPoint);
  
                  setTimeout(() => {
                    if (
                      ms_element.meteringPoints &&
                      ms_element.meteringPoints.length > 0 &&
                      this.meteringPointManagement != "no-access"
                    ) {
                      ms_element.meteringPoints.forEach(
                        (mp_element: any, mp_index: any, mp_array: any[]) => {
                          let deviceArr: any = [];
  
                          if (
                            mp_element.meters &&
                            mp_element.meters.length > 0 &&
                            this.deviceManagement != "no-access"
                          ) {
                            //only display for where there is meters
                            deviceArr.push({
                              type: "statement",
                              icon: "",
                              userAccount: "yes",
                              imgSrc: "assets/dashboard/menu/doc.png",
                              text: "View Statement",
                              key: mp_element.meteringPointID,
                              level: "statement",
                            });
  
                            mp_element.meters.forEach(
                              (
                                mt_element: any,
                                mt_index: any,
                                mt_array: any[]
                              ) => {
                                let ext = ".svg";
                                if (
                                  mt_element.meterType != "water" &&
                                  mt_element.meterType != "electricity" &&
                                  mt_element.meterType != "gas"
                                )
                                  ext = ".png";
                                deviceArr.push({
                                  type: "",
                                  text: mt_element.deviceName,
                                  icon: "",
                                  imgSrc:
                                    "assets/dashboard/menu/" +
                                    mt_element.meterType +
                                    ext,
                                  level: "device",
                                  key: mt_element.deviceID,
                                  deviceType: mt_element.deviceType,
                                  meterType: mt_element.meterType,
                                  deviceVersion: mt_element.version,
                                  isActive:mt_element.isActive
                                });
                              }
                            );
                          }
  
                          let meteringPoint: SideNavItem = {
                            icon: "",
                            imgSrc:
                              this.companyCheck == "landis"
                                ? "assets/landis-assets/images/verticalbuilding.svg"
                                : "assets/dashboard/menu/vertical-building.svg",
                            text: mp_element.meteringPointName,
                            totalMeters: mp_element.totalMeters,
                            submenu: deviceArr,
                            key: mp_element.meteringPointID,
                            level: "meteringPoint",
                          };
                          meteringPoints.push(meteringPoint);
                          // this.changeDetectorRef.detectChanges();
                          if (mp_index === mp_array.length - 1) {
                            this.changeDetectorRef.markForCheck();
                          }
                          mp_index = mp_index + 1;
                        }
                      );
                    }
                  }, 1000);
  
                  let meteringSection: SideNavItem = {
                    icon: "",
                    imgSrc: "assets/landis-assets/images/meteringsectionicon.svg",
                    text: ms_element.meteringSectionName,
                    submenu: meteringPoints,
                    key: ms_element.meteringSectionID,
                    level: "meteringSection",
                  };
                  meteringSections.push(meteringSection);
                  // this.changeDetectorRef.detectChanges();
                  if (ms_index === ms_array.length - 1) {
                    this.changeDetectorRef.markForCheck();
                  }
                  ms_index = ms_index + 1;
                }
              );
            }
  
            // adding value 1st child
            let dataitem: SideNavItems = {
              [element.meteringFarmID]: {
                icon: "",
                imgSrc:
                  this.companyCheck == "landis"
                    ? "assets/landis-assets/images/meteringfarm.svg"
                    : "assets/dashboard/menu/tree.svg",
                text: element.meteringFarmName,
                submenu: meteringSections,
                key: element.meteringFarmID,
                level: "meteringFarm",
              },
            };
  
            sideNavItemsList.AddData(dataitem);
            this.changeDetectorRef.detectChanges();
          });
        }
  
        if (
          data.data.meteringSections &&
          data.data.meteringSections.length > 0 &&
          this.meteringSectionManagement != "no-access"
        ) {
          data.data.meteringSections.forEach(
            (ms_element: any, ms_index: any, ms_array: any[]) => {
              // adding value to parent menu
              let _keyValue: keyvalue = {} as keyvalue;
              _keyValue.key = ms_element.meteringSectionID;
              _keyValue.value = ms_element.meteringSectionName;
              this.sideNavSections[0].items.push(_keyValue);
  
              let meteringPoints: any = [];
  
              //Add for each metering section
              let meteringPoint = {
                type: "modems",
                icon: "",
                userAccount: "yes",
                imgSrc:
                  this.companyCheck == "landis"
                    ? "assets/landis-assets/images/modems.png"
                    : "assets/dashboard/menu/modem.png",
                text: "Modems/Gateways",
                key: ms_element.meteringSectionID,
                level: "modems",
              };
              meteringPoints.push(meteringPoint);
  
              setTimeout(() => {
                if (
                  ms_element.meteringPoints &&
                  ms_element.meteringPoints.length > 0 &&
                  this.meteringPointManagement != "no-access"
                ) {
                  ms_element.meteringPoints.forEach(
                    (mp_element: any, mp_index: any, mp_array: any[]) => {
                      let deviceArr: any = [];
  
                      if (
                        mp_element.meters &&
                        mp_element.meters.length > 0 &&
                        this.deviceManagement != "no-access"
                      ) {
                        //only display for where there is meters
                        deviceArr.push({
                          type: "statement",
                          icon: "",
                          userAccount: "yes",
                          imgSrc: "assets/dashboard/menu/doc.png",
                          text: "View Statement",
                          key: mp_element.meteringPointID,
                          level: "statement",
                        });
  
                        mp_element.meters.forEach(
                          (mt_element: any, mt_index: any, mt_array: any[]) => {
                            let ext = ".svg";
                            if (
                              mt_element.meterType != "water" &&
                              mt_element.meterType != "electricity" &&
                              mt_element.meterType != "gas"
                            )
                              ext = ".png";
                            deviceArr.push({
                              type: "",
                              text: mt_element.deviceName,
                              icon: "",
                              imgSrc:
                                "assets/dashboard/menu/" +
                                mt_element.meterType +
                                ext,
                              level: "device",
                              key: mt_element.deviceID,
                              deviceType: mt_element.deviceType,
                              meterType: mt_element.meterType,
                              deviceVersion: mt_element.version,
                              isActive:mt_element.isActive
                            });
                          }
                        );
                      }
  
                      let meteringPoint: SideNavItem = {
                        icon: "",
                        imgSrc:
                          this.companyCheck == "landis"
                            ? "assets/landis-assets/images/verticalbuilding.svg"
                            : "assets/dashboard/menu/vertical-building.svg",
                        text: mp_element.meteringPointName,
                        totalMeters: mp_element.totalMeters,
                        submenu: deviceArr,
                        key: mp_element.meteringPointID,
                        level: "meteringPoint",
                      };
                      meteringPoints.push(meteringPoint);
                      // this.changeDetectorRef.detectChanges();
                      if (mp_index === mp_array.length - 1) {
                        this.changeDetectorRef.markForCheck();
                      }
                      mp_index = mp_index + 1;
                    }
                  );
                }
              }, 1000);
  
              // adding value 1st child
              let dataitem: SideNavItems = {
                [ms_element.meteringSectionID]: {
                  icon: "",
                  imgSrc:
                    this.companyCheck == "landis"
                      ? "assets/landis-assets/images/meteringsectionicon.svg"
                      : "assets/dashboard/menu/building.svg",
                  text: ms_element.meteringSectionName,
                  submenu: meteringPoints,
                  key: ms_element.meteringSectionID,
                  level: "meteringSection",
                },
              };
  
              sideNavItemsList.AddData(dataitem);
              this.changeDetectorRef.detectChanges();
            }
          );
        }
  
        if (
          data.data.meteringPoints &&
          data.data.meteringPoints.length > 0 &&
          this.meteringPointManagement != "no-access"
        ) {
          data.data.meteringPoints.forEach(
            (mp_element: any, mp_index: any, mp_array: any[]) => {
              // adding value to parent menu
              let _keyValue: keyvalue = {} as keyvalue;
              _keyValue.key = mp_element.meteringPointID;
              (_keyValue.value = mp_element.meteringPointName),
                (_keyValue.totalMeters = mp_element.totalMeters),
                this.sideNavSections[0].items.push(_keyValue);
  
              let deviceArr: any = [];
  
              setTimeout(() => {
                if (
                  mp_element.meters &&
                  mp_element.meters.length > 0 &&
                  this.deviceManagement != "no-access"
                ) {
                  //only display for where there is meters
                  deviceArr.push({
                    type: "statement",
                    icon: "",
                    userAccount: "yes",
                    imgSrc: "assets/dashboard/menu/doc.png",
                    text: "View Statement",
                    key: mp_element.meteringPointID,
                    level: "statement",
                  });
  
                  mp_element.meters.forEach(
                    (mt_element: any, mt_index: any, mt_array: any[]) => {
                      let ext = ".svg";
                      if (
                        mt_element.meterType != "water" &&
                        mt_element.meterType != "electricity" &&
                        mt_element.meterType != "gas"
                      )
                        ext = ".png";
                      deviceArr.push({
                        type: "",
                        text: mt_element.deviceName,
                        icon: "",
                        imgSrc:
                          "assets/dashboard/menu/" + mt_element.meterType + ext,
                        level: "device",
                        key: mt_element.deviceID,
                        deviceType: mt_element.deviceType,
                        meterType: mt_element.meterType,
                        deviceVersion: mt_element.version,
                        isActive:mt_element.isActive
                        
                      });
                    }
                  );
                }
              }, 1000);
  
              // adding value 1st child
              let dataitem: SideNavItems = {
                [mp_element.meteringPointID]: {
                  icon: "",
                  imgSrc:
                    this.companyCheck == "landis"
                      ? "assets/landis-assets/images/meteringsectionicon.svg"
                      : "assets/dashboard/menu/building.svg",
                  text: mp_element.meteringPointName,
                  totalMeters: mp_element.totalMeters,
                  submenu: deviceArr,
                  key: mp_element.meteringPointID,
                  level: "meteringPoint",
                },
              };
  
              sideNavItemsList.AddData(dataitem);
              this.changeDetectorRef.detectChanges();
            }
          );
        }
        localStorage.setItem("menuLoaded", "yes");
        this.reloadNav = "yes";
        this.changeDetectorRef.detectChanges();
        this.changeDetectorRef.markForCheck();
      }
     })
   

    // },
    // (error: any) => {
    //     const defaultOptions = {
    //         autohide: true,
    //         delay: 10000,
    //     };
    //     localStorage.clear();
    //     console.log(error);
    //     let message = "";
    //     for (var i = 0; i < error.error.data.length; i++) {
    //         message += error.error.data[i] + "\n";
    //     }
    //     this.toastService.show("No Devices", error.error.data, { headerClasses: 'bg-danger text-light', ...defaultOptions });
    //     this.router.navigateByUrl("/auth/login");
    // });
  }

  async LoadMeteringHeirachyOLD() {

   
    if(this.unapprovedRegisteredUser == 'true'){
      return
    }


    let permissions:any = this.permissionsService.getAll();
    // let permissions:any = await this.secureStorage.getItem('permissions');
    // permissions =  JSON.parse(permissions);

    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest
      .apiRequest(
        "metering/metering_hierarchy/",
        "metering_hierarchy.json",
        body
      )
      .subscribe(
        (data) => {
          if (data.success == true) {
            this.sideNavSections[0].items = [];
            if (
              data.data.meteringFarms &&
              data.data.meteringFarms.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringFarms.forEach((element: any) => {
                // adding value to parent menu
                let _keyValue: keyvalue = {} as keyvalue;
                _keyValue.key = element.meteringFarmID;
                _keyValue.value = element.meteringFarmName;
                this.sideNavSections[0].items.push(_keyValue);
                let meteringSections: any = [];

                if (
                  element.meteringSections &&
                  element.meteringSections.length > 0 &&
                  this.meteringSectionManagement != "no-access"
                ) {
                  element.meteringSections.forEach(
                    (ms_element: any, ms_index: any, ms_array: any[]) => {

                      let meteringPoints: any = [];

                      //Add for each metering section
                      let meteringPoint = {
                        type: "modems",
                        icon: "",
                        userAccount: "yes",
                        imgSrc:
                          this.companyCheck == "landis"
                            ? "assets/landis-assets/images/modems.png"
                            : "assets/dashboard/menu/modem.png",
                        text: "Modems/Gateways",
                        key: ms_element.meteringSectionID,
                        level: "modems",
                      };
                      meteringPoints.push(meteringPoint);

                      setTimeout(() => {
                        if (
                          ms_element.meteringPoints &&
                          ms_element.meteringPoints.length > 0 &&
                          this.meteringPointManagement != "no-access"
                        ) {
                          ms_element.meteringPoints.forEach(
                            (
                              mp_element: any,
                              mp_index: any,
                              mp_array: any[]
                            ) => {
                              let deviceArr: any = [];
                              if (
                                mp_element.meters &&
                                mp_element.meters.length > 0 &&
                                this.deviceManagement != "no-access"
                              ) {

                                //only display for where there is meters
                              

                                
                                if(mp_element.thinPrepaymentStatus == 'enabled'){
                                  deviceArr.push({
                                    type: "wallet",
                                    icon: "",
                                    userAccount: "yes",
                                    imgSrc: "assets/dashboard/wallet.png",
                                    text: "Wallet Dashboard",
                                    key: mp_element.meteringPointID,
                                    level: "wallet",
                                  });
                                }else{
                                  deviceArr.push({
                                    type: "statement",
                                    icon: "",
                                    userAccount: "yes",
                                    imgSrc: "assets/dashboard/menu/doc.png",
                                    text: "View Statement",
                                    key: mp_element.meteringPointID,
                                    level: "statement",
                                  });
                                }
                               
                               
                               

                                mp_element.meters.forEach(
                                  (
                                    mt_element: any,
                                    mt_index: any,
                                    mt_array: any[]
                                  ) => {
                                    let ext = ".svg";
                                    if (
                                      mt_element.meterType != "water" &&
                                      mt_element.meterType != "electricity" &&
                                      mt_element.meterType != "gas"
                                    )
                                      ext = ".png";
                                    deviceArr.push({
                                      type: "",
                                      text: mt_element.deviceName,
                                      icon: "",
                                      imgSrc:
                                        "assets/dashboard/menu/" +
                                        mt_element.meterType +
                                        ext,
                                      level: "device",
                                      key: mt_element.deviceID,
                                      deviceType: mt_element.deviceType,
                                      meterType: mt_element.meterType,
                                      deviceVersion: mt_element.version,
                                      isActive:mt_element.isActive
                                    });
                                  }
                                  
                                );

                               
                              }

                              let meteringPoint: SideNavItem = {
                                icon: "",
                                imgSrc:
                                  this.companyCheck == "landis"
                                    ? "assets/landis-assets/images/verticalbuilding.svg"
                                    : "assets/dashboard/menu/vertical-building.svg",
                                text: mp_element.meteringPointName,
                                totalMeters: mp_element.totalMeters,
                                submenu: deviceArr,
                                key: mp_element.meteringPointID,
                                level: "meteringPoint",
                              };
                              meteringPoints.push(meteringPoint);
                              // this.changeDetectorRef.detectChanges();
                              if (mp_index === mp_array.length - 1) {
                                this.changeDetectorRef.markForCheck();
                              }
                              mp_index = mp_index + 1;
                            }
                          );
                        }
                      }, 1000);

                      let meteringSection: SideNavItem = {
                        icon: "",
                        imgSrc:
                          this.companyCheck == "landis"
                            ? "assets/landis-assets/images/meteringsectionicon.svg"
                            : "assets/dashboard/menu/building.svg",
                        text: ms_element.meteringSectionName,
                        submenu: meteringPoints,
                        key: ms_element.meteringSectionID,
                        level: "meteringSection",
                      };
                      meteringSections.push(meteringSection);
                      // this.changeDetectorRef.detectChanges();
                      if (ms_index === ms_array.length - 1) {
                        this.changeDetectorRef.markForCheck();
                      }
                      ms_index = ms_index + 1;
                    }
                  );
                }

                // adding value 1st child
                let dataitem: SideNavItems = {
                  [element.meteringFarmID]: {
                    icon: "",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/meteringfarm.svg"
                        : "assets/dashboard/menu/tree.svg",
                    text: element.meteringFarmName,
                    submenu: meteringSections,
                    key: element.meteringFarmID,
                    level: "meteringFarm",
                  },
                };

                sideNavItemsList.AddData(dataitem);
                this.changeDetectorRef.detectChanges();
              });
            }

            if (
              data.data.meteringSections &&
              data.data.meteringSections.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringSections.forEach(
                (ms_element: any, ms_index: any, ms_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = ms_element.meteringSectionID;
                  _keyValue.value = ms_element.meteringSectionName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let meteringPoints: any = [];

                  //Add for each metering section
                  let meteringPoint = {
                    type: "modems",
                    icon: "",
                    userAccount: "yes",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/modems.png"
                        : "assets/dashboard/menu/modem.png",
                    text: "Modems/Gateways",
                    key: ms_element.meteringSectionID,
                    level: "modems",
                  };
                  meteringPoints.push(meteringPoint);

                  setTimeout(() => {
                    if (
                      ms_element.meteringPoints &&
                      ms_element.meteringPoints.length > 0 &&
                      this.meteringPointManagement != "no-access"
                    ) {
                      ms_element.meteringPoints.forEach(
                        (mp_element: any, mp_index: any, mp_array: any[]) => {
                          let deviceArr: any = [];

                          if (
                            mp_element.meters &&
                            mp_element.meters.length > 0 &&
                            this.deviceManagement != "no-access"
                          ) {
                            //only display for where there is meters
                          

                            if(mp_element.thinPrepaymentStatus == 'enabled'){
                              deviceArr.push({
                                type: "wallet",
                                icon: "",
                                userAccount: "yes",
                                imgSrc: "assets/dashboard/wallet.png",
                                text: "Wallet Dashboard",
                                key: mp_element.meteringPointID,
                                level: "wallet",
                              });
                            }else{
                              deviceArr.push({
                                type: "statement",
                                icon: "",
                                userAccount: "yes",
                                imgSrc: "assets/dashboard/menu/doc.png",
                                text: "View Statement",
                                key: mp_element.meteringPointID,
                                level: "statement",
                              });
                            }

                          

                           

                            mp_element.meters.forEach(
                              (
                                mt_element: any,
                                mt_index: any,
                                mt_array: any[]
                              ) => {
                                let ext = ".svg";
                                if (
                                  mt_element.meterType != "water" &&
                                  mt_element.meterType != "electricity" &&
                                  mt_element.meterType != "gas"
                                )
                                  ext = ".png";
                                deviceArr.push({
                                  type: "",
                                  text: mt_element.deviceName,
                                  icon: "",
                                  imgSrc:
                                    "assets/dashboard/menu/" +
                                    mt_element.meterType +
                                    ext,
                                  level: "device",
                                  key: mt_element.deviceID,
                                  deviceType: mt_element.deviceType,
                                  meterType: mt_element.meterType,
                                  deviceVersion: mt_element.version,
                                  isActive:mt_element.isActive
                                });
                              }
                            );
                           
                          }

                          let meteringPoint: SideNavItem = {
                            icon: "",
                            imgSrc:
                              this.companyCheck == "landis"
                                ? "assets/landis-assets/images/verticalbuilding.svg"
                                : "assets/dashboard/menu/vertical-building.svg",
                            text: mp_element.meteringPointName,
                            totalMeters: mp_element.totalMeters,
                            submenu: deviceArr,
                            key: mp_element.meteringPointID,
                            level: "meteringPoint",
                          };
                          meteringPoints.push(meteringPoint);
                          // this.changeDetectorRef.detectChanges();
                          if (mp_index === mp_array.length - 1) {
                            this.changeDetectorRef.markForCheck();
                          }
                          mp_index = mp_index + 1;
                        }
                      );
                    }
                  }, 1000);

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [ms_element.meteringSectionID]: {
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: ms_element.meteringSectionName,
                      submenu: meteringPoints,
                      key: ms_element.meteringSectionID,
                      level: "meteringSection",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            if (
              data.data.meteringPoints &&
              data.data.meteringPoints.length > 0 &&
              this.meteringPointManagement != "no-access"
            ) {
              data.data.meteringPoints.forEach(
                (mp_element: any, mp_index: any, mp_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = mp_element.meteringPointID;
                  (_keyValue.value = mp_element.meteringPointName),
                    (_keyValue.totalMeters = mp_element.totalMeters),
                    this.sideNavSections[0].items.push(_keyValue);

                  let deviceArr: any = [];

                  setTimeout(() => {
                    if (
                      mp_element.meters &&
                      mp_element.meters.length > 0 &&
                      this.deviceManagement != "no-access"
                    ) {
                      //only display for where there is meters
                   
                      
                       if(mp_element.thinPrepaymentStatus == 'enabled'){
                        deviceArr.push({
                          type: "wallet",
                          icon: "",
                          userAccount: "yes",
                          imgSrc: "assets/dashboard/wallet.png",
                          text: "Wallet Dashboard",
                          key: mp_element.meteringPointID,
                          level: "wallet",
                        });
                       }else{
                        deviceArr.push({
                          type: "statement",
                          icon: "",
                          userAccount: "yes",
                          imgSrc: "assets/dashboard/menu/doc.png",
                          text: "View Statement",
                          key: mp_element.meteringPointID,
                          level: "statement",
                        });
                       }

                      mp_element.meters.forEach(
                        (mt_element: any, mt_index: any, mt_array: any[]) => {
                          let ext = ".svg";
                          if (
                            mt_element.meterType != "water" &&
                            mt_element.meterType != "electricity" &&
                            mt_element.meterType != "gas"
                          )
                            ext = ".png";
                          deviceArr.push({
                            type: "",
                            text: mt_element.deviceName,
                            icon: "",
                            imgSrc:
                              "assets/dashboard/menu/" +
                              mt_element.meterType +
                              ext,
                            level: "device",
                            key: mt_element.deviceID,
                            deviceType: mt_element.deviceType,
                            meterType: mt_element.meterType,
                            deviceVersion: mt_element.version,
                            isActive:mt_element.isActive
                          });
                        }
                      );
                    
                    }
                  }, 1000);

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [mp_element.meteringPointID]: {
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: mp_element.meteringPointName,
                      totalMeters: mp_element.totalMeters,
                      submenu: deviceArr,
                      key: mp_element.meteringPointID,
                      level: "meteringPoint",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }
            localStorage.setItem("menuLoaded", "yes");
            this.reloadNav = "yes";
            this.changeDetectorRef.detectChanges();
            this.changeDetectorRef.markForCheck();
            localStorage.setItem("reload", "no");
          }
        },
        async (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 10000,
          };
          // Keep session intact on hierarchy load failures.
          console.log(error);
          let message = "";
            if (error.error && error.error.data && Array.isArray(error.error.data)) {
            if (error && error.error && Array.isArray(error.error.data)) {
              if (error && error.error && Array.isArray(error.error.data)) {
                for (var i = 0; i < error.error.data.length; i++) {
                  message += error.error.data[i] + "\n";
                }
              }
            } else if (error && error.error && typeof error.error.data === "string") {
              message = error.error.data;
            } else if (error && error.message) {
              message = error.message;
            } else {
              message = "An unknown error occurred.";
            }
            this.toastService.show("No Devices", error.error.data, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
            } else {
            message = error.message || "An unexpected error occurred.";
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
            }
          return;
        }
      );
  }

  async LoadAccountHeirachyJson() {
    let permissions:any = this.permissionsService.getAll();
    // let permissions:any = await this.secureStorage.getItem('permissions');
    // permissions =  JSON.parse(permissions);


    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    var data: any = JSON.parse(
      localStorage.getItem("account_hierarchy") as string
    );

    // this.apiRequest.apiRequest('metering/account_hierarchy/', 'account_hierarchy.json', body)
    // .subscribe(data => {
    if (data.success) {
      this.sideNavSections[0].items = [];
      if (
        data.data.meteringFarms &&
        data.data.meteringFarms.length > 0 &&
        this.meteringSectionManagement != "no-access"
      ) {
        let meteringFarms: any = [];

        data.data.meteringFarms.forEach((element: any) => {
          // adding value to parent menu
          let _keyValue: keyvalue = {} as keyvalue;
          _keyValue.key = element.meteringFarmID;
          _keyValue.value = element.meteringFarmName;
          this.sideNavSections[0].items.push(_keyValue);
          let meteringSections: any = [];

          let meteringSectionAllUsers: SideNavItem = {
            type: "account",
            icon: "",
            userAccount: "yes",
            pmLevel: "all",
            imgSrc: this.companyCheck == "landis"
            ? "assets/landis-assets/images/landisUserAll.png"
            : "assets/dashboard/menu/userAll.png",
            text: "All Accounts",
            textLevel: element.meteringFarmName,
            submenu: [],
            key: element.meteringFarmID,
            level: "meteringFarm",
          };
          meteringSections.push(meteringSectionAllUsers);

          let meteringSectionAdminUsers: SideNavItem = {
            type: "account",
            icon: "",
            userAccount: "yes",
            pmLevel: "1",
            imgSrc: this.companyCheck == "landis"
            ? "assets/landis-assets/images/landisUserAdmin.png"
            : "assets/dashboard/menu/userAdmin.png",
            text: "Admins Only",
            textLevel: element.meteringFarmName,
            submenu: [],
            key: element.meteringFarmID,
            level: "meteringFarm",
          };
          meteringSections.push(meteringSectionAdminUsers);

          if (
            element.meteringSections &&
            element.meteringSections.length > 0 &&
            this.meteringSectionManagement != "no-access"
          ) {
            element.meteringSections.forEach(
              (ms_element: any, ms_index: any, ms_array: any[]) => {
                let meteringPoints: any = [];

                setTimeout(() => {
                  if (
                    ms_element.meteringPoints &&
                    ms_element.meteringPoints.length > 0 &&
                    this.meteringPointManagement != "no-access"
                  ) {
                    ms_element.meteringPoints.forEach(
                      (mp_element: any, mp_index: any, mp_array: any[]) => {
                        let deviceArr: any = [];

                        if (
                          mp_element.meters &&
                          mp_element.meters.length > 0 &&
                          this.deviceManagement != "no-access"
                        ) {
                          mp_element.meters.forEach(
                            (
                              mt_element: any,
                              mt_index: any,
                              mt_array: any[]
                            ) => {
                              let ext = ".svg";
                              if (
                                mt_element.meterType != "water" &&
                                mt_element.meterType != "electricity" &&
                                mt_element.meterType != "gas"
                              )
                                ext = ".png";
                              deviceArr.push({
                                type: "account",
                                text: mt_element.deviceName,
                                icon: "",
                                imgSrc:
                                  "assets/dashboard/menu/" +
                                  mt_element.meterType +
                                  ext,
                                level: "device",
                                key: mt_element.deviceID,
                                deviceType: mt_element.deviceType,
                                meterType: mt_element.meterType,
                                deviceVersion: mt_element.version,
                                isActive:mt_element.isActive
                              });
                            }
                          );
                        }

                        let meteringPoint: SideNavItem = {
                          type: "account",
                          icon: "",
                          imgSrc:
                            this.companyCheck == "landis"
                              ? "assets/landis-assets/images/verticalbuilding.svg"
                              : "assets/dashboard/menu/vertical-building.svg",
                          text: mp_element.meteringPointName,
                          submenu: deviceArr,
                          key: mp_element.meteringPointID,
                          level: "meteringPoint",
                        };
                        meteringPoints.push(meteringPoint);
                        // this.changeDetectorRef.detectChanges();
                        if (mp_index === mp_array.length - 1) {
                          this.changeDetectorRef.markForCheck();
                        }
                        mp_index = mp_index + 1;
                      }
                    );
                  }
                }, 1000);

                let meteringSectionAllUsers: SideNavItem = {
                  type: "account",
                  icon: "",
                  userAccount: "yes",
                  pmLevel: "all",
                  imgSrc: this.companyCheck == "landis"
                  ? "assets/landis-assets/images/landisUserAll.png"
                  : "assets/dashboard/menu/userAll.png",
                  text: "All Accounts",
                  textLevel: ms_element.meteringSectionName,
                  submenu: [],
                  key: ms_element.meteringSectionID,
                  level: "meteringSection",
                };
                meteringPoints.push(meteringSectionAllUsers);

                let meteringSectionAdminUsers: SideNavItem = {
                  type: "account",
                  icon: "",
                  userAccount: "yes",
                  pmLevel: "2",
                  imgSrc: this.companyCheck == "landis"
                  ? "assets/landis-assets/images/landisUserAdmin.png"
                  : "assets/dashboard/menu/userAdmin.png",
                  text: "Managers Only",
                  textLevel: ms_element.meteringSectionName,
                  submenu: [],
                  key: ms_element.meteringSectionID,
                  level: "meteringSection",
                };
                meteringPoints.push(meteringSectionAdminUsers);

                let meteringSection: SideNavItem = {
                  type: "account",
                  icon: "",
                  imgSrc:
                    this.companyCheck == "landis"
                      ? "assets/landis-assets/images/meteringsectionicon.svg"
                      : "assets/dashboard/menu/building.svg",
                  text: ms_element.meteringSectionName,
                  submenu: meteringPoints,
                  key: ms_element.meteringSectionID,
                  level: "meteringSection",
                };
                meteringSections.push(meteringSection);

                // this.changeDetectorRef.detectChanges();
                if (ms_index === ms_array.length - 1) {
                  this.changeDetectorRef.markForCheck();
                }
                ms_index = ms_index + 1;
              }
            );
          }

          // adding value 1st child
          let dataitem: SideNavItems = {
            [element.meteringFarmID]: {
              type: "account",
              icon: "",
              imgSrc:
                this.companyCheck == "landis"
                  ? "assets/landis-assets/images/meteringfarm.svg"
                  : "assets/dashboard/menu/tree.svg",
              text: element.meteringFarmName,
              submenu: meteringSections,
              key: element.meteringFarmID,
              level: "meteringFarm",
            },
          };

          sideNavItemsList.AddData(dataitem);
          this.changeDetectorRef.detectChanges();
        });
      }

      if (
        data.data.meteringSections &&
        data.data.meteringSections.length > 0 &&
        this.meteringSectionManagement != "no-access"
      ) {
        data.data.meteringSections.forEach(
          (ms_element: any, ms_index: any, ms_array: any[]) => {
            // adding value to parent menu
            let _keyValue: keyvalue = {} as keyvalue;
            _keyValue.key = ms_element.meteringSectionID;
            _keyValue.value = ms_element.meteringSectionName;
            this.sideNavSections[0].items.push(_keyValue);

            let meteringPoints: any = [];

            setTimeout(() => {
              if (
                ms_element.meteringPoints &&
                ms_element.meteringPoints.length > 0 &&
                this.meteringPointManagement != "no-access"
              ) {
                ms_element.meteringPoints.forEach(
                  (mp_element: any, mp_index: any, mp_array: any[]) => {
                    let deviceArr: any = [];

                    if (
                      mp_element.meters &&
                      mp_element.meters.length > 0 &&
                      this.deviceManagement != "no-access"
                    ) {
                      mp_element.meters.forEach(
                        (mt_element: any, mt_index: any, mt_array: any[]) => {
                          // deviceArr.push({
                          //     type: 'account',
                          //     text: mt_element.deviceName,
                          //     icon: '',
                          //     imgSrc: 'assets/dashboard/menu/' + mt_element.meterType + '.svg',
                          //     level: "device",
                          //     key: mt_element.deviceID,
                          //     deviceType: mt_element.deviceType,
                          //     meterType: mt_element.meterType,
                          // })
                        }
                      );
                    }

                    let meteringPoint: SideNavItem = {
                      type: "account",
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/verticalbuilding.svg"
                          : "assets/dashboard/menu/vertical-building.svg",
                      text: mp_element.meteringPointName,
                      submenu: deviceArr,
                      key: mp_element.meteringPointID,
                      level: "meteringPoint",
                    };
                    meteringPoints.push(meteringPoint);
                    // this.changeDetectorRef.detectChanges();
                    if (mp_index === mp_array.length - 1) {
                      this.changeDetectorRef.markForCheck();
                    }
                    mp_index = mp_index + 1;
                  }
                );
              }
            }, 1000);

            let meteringSectionAllUsers: SideNavItem = {
              type: "account",
              icon: "",
              userAccount: "yes",
              pmLevel: "all",
              imgSrc: this.companyCheck == "landis"
              ? "assets/landis-assets/images/landisUserAll.png"
              : "assets/dashboard/menu/userAll.png",
              text: "All Accounts",
              textLevel: ms_element.meteringSectionName,
              submenu: [],
              key: ms_element.meteringSectionID,
              level: "meteringSection",
            };
            meteringPoints.push(meteringSectionAllUsers);

            let meteringSectionAdminUsers: SideNavItem = {
              type: "account",
              icon: "",
              userAccount: "yes",
              pmLevel: "2",
              imgSrc: this.companyCheck == "landis"
              ? "assets/landis-assets/images/landisUserAdmin.png"
              : "assets/dashboard/menu/userAdmin.png",
              text: "Managers Only",
              textLevel: ms_element.meteringSectionName,
              submenu: [],
              key: ms_element.meteringSectionID,
              level: "meteringSection",
            };
            meteringPoints.push(meteringSectionAdminUsers);

            // adding value 1st child
            let dataitem: SideNavItems = {
              [ms_element.meteringSectionID]: {
                type: "account",
                icon: "",
                imgSrc:
                  this.companyCheck == "landis"
                    ? "assets/landis-assets/images/meteringsectionicon.svg"
                    : "assets/dashboard/menu/building.svg",
                text: ms_element.meteringSectionName,
                submenu: meteringPoints,
                key: ms_element.meteringSectionID,
                level: "meteringSection",
              },
            };

            sideNavItemsList.AddData(dataitem);
            this.changeDetectorRef.detectChanges();
          }
        );
      }

      if (
        data.data.meteringPoints &&
        data.data.meteringPoints.length > 0 &&
        this.meteringPointManagement != "no-access"
      ) {
        data.data.meteringPoints.forEach(
          (mp_element: any, mp_index: any, mp_array: any[]) => {
            // adding value to parent menu
            let _keyValue: keyvalue = {} as keyvalue;
            _keyValue.key = mp_element.meteringPointID;
            _keyValue.value = mp_element.meteringPointName;
            this.sideNavSections[0].items.push(_keyValue);

            let deviceArr: any = [];

            setTimeout(() => {
              if (
                mp_element.meters &&
                mp_element.meters.length > 0 &&
                this.deviceManagement != "no-access"
              ) {
                mp_element.meters.forEach(
                  (mt_element: any, mt_index: any, mt_array: any[]) => {
                    let ext = ".svg";
                    if (
                      mt_element.meterType != "water" &&
                      mt_element.meterType != "electricity" &&
                      mt_element.meterType != "gas"
                    )
                      ext = ".png";
                    deviceArr.push({
                      type: "account",
                      text: mt_element.deviceName,
                      icon: "",
                      imgSrc:
                        "assets/dashboard/menu/" + mt_element.meterType + ext,
                      level: "device",
                      key: mt_element.deviceID,
                      deviceType: mt_element.deviceType,
                      meterType: mt_element.meterType,
                      deviceVersion: mt_element.version,
                      isActive:mt_element.isActive
                    });
                  }
                );
              }
            }, 1000);

            // adding value 1st child
            let dataitem: SideNavItems = {
              [mp_element.meteringPointID]: {
                type: "account",
                icon: "",
                imgSrc:
                  this.companyCheck == "landis"
                    ? "assets/landis-assets/images/meteringsectionicon.svg"
                    : "assets/dashboard/menu/building.svg",
                text: mp_element.meteringPointName,
                submenu: deviceArr,
                key: mp_element.meteringPointID,
                level: "meteringPoint",
              },
            };

            sideNavItemsList.AddData(dataitem);
            this.changeDetectorRef.detectChanges();
          }
        );
      }
      localStorage.setItem("menuLoaded", "yes");
      this.reloadNav = "yes";
      this.changeDetectorRef.detectChanges();
      this.changeDetectorRef.markForCheck();
    }

    // },
    // (error: any) => {
    //     const defaultOptions = {
    //         autohide: true,
    //         delay: 10000,
    //     };
    //     localStorage.clear();
    //     console.log(error);
    //     let message = "";
    //     for (var i = 0; i < error.error.data.length; i++) {
    //         message += error.error.data[i] + "\n";
    //     }
    //     this.toastService.show("No Devices", error.error.data, { headerClasses: 'bg-danger text-light', ...defaultOptions });
    //     this.router.navigateByUrl("/auth/login");
    // });
  }

  async LoadAccountHeirachyOLD() {

    let permissions:any = this.permissionsService.getAll();
    // let permissions:any = await this.secureStorage.getItem('permissions');
    // permissions =  JSON.parse(permissions);
  

    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    // var data: any = JSON.parse(localStorage.getItem('account_hierarchy') as string);

    this.apiRequest
      .apiRequest("metering/account_hierarchy/", "account_hierarchy.json", body)
      .subscribe(
        (data) => {
          if (data.success == true) {
            console.log("Save json account_hierarchy");
            this.sideNavSections[0].items = [];
            if (
              data.data.meteringFarms &&
              data.data.meteringFarms.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              let meteringFarms: any = [];

              data.data.meteringFarms.forEach((element: any) => {
                // adding value to parent menu
                let _keyValue: keyvalue = {} as keyvalue;
                _keyValue.key = element.meteringFarmID;
                _keyValue.value = element.meteringFarmName;
                this.sideNavSections[0].items.push(_keyValue);
                let meteringSections: any = [];

                let meteringSectionAllUsers: SideNavItem = {
                  type: "account",
                  icon: "",
                  userAccount: "yes",
                  pmLevel: "all",
                  imgSrc: this.companyCheck == "landis"
                  ? "assets/landis-assets/images/landisUserAll.png"
                  : "assets/dashboard/menu/userAll.png",
                  text: "All Accounts",
                  textLevel: element.meteringFarmName,
                  submenu: [],
                  key: element.meteringFarmID,
                  level: "meteringFarm",
                };
                meteringSections.push(meteringSectionAllUsers);

                let meteringSectionAdminUsers: SideNavItem = {
                  type: "account",
                  icon: "",
                  userAccount: "yes",
                  pmLevel: "1",
                  imgSrc: this.companyCheck == "landis"
                  ? "assets/landis-assets/images/landisUserAdmin.png"
                  : "assets/dashboard/menu/userAdmin.png",
                  text: "Admins Only",
                  textLevel: element.meteringFarmName,
                  submenu: [],
                  key: element.meteringFarmID,
                  level: "meteringFarm",
                };
                meteringSections.push(meteringSectionAdminUsers);

                if (
                  element.meteringSections &&
                  element.meteringSections.length > 0 &&
                  this.meteringSectionManagement != "no-access"
                ) {
                  element.meteringSections.forEach(
                    (ms_element: any, ms_index: any, ms_array: any[]) => {
                      let meteringPoints: any = [];

                      setTimeout(() => {
                        if (
                          ms_element.meteringPoints &&
                          ms_element.meteringPoints.length > 0 &&
                          this.meteringPointManagement != "no-access"
                        ) {
                          ms_element.meteringPoints.forEach(
                            (
                              mp_element: any,
                              mp_index: any,
                              mp_array: any[]
                            ) => {
                              let deviceArr: any = [];

                              if (
                                mp_element.meters &&
                                mp_element.meters.length > 0 &&
                                this.deviceManagement != "no-access"
                              ) {
                                mp_element.meters.forEach(
                                  (
                                    mt_element: any,
                                    mt_index: any,
                                    mt_array: any[]
                                  ) => {
                                    let ext = ".svg";
                                    if (
                                      mt_element.meterType != "water" &&
                                      mt_element.meterType != "electricity" &&
                                      mt_element.meterType != "gas"
                                    )
                                      ext = ".png";
                                    deviceArr.push({
                                      type: "account",
                                      text: mt_element.deviceName,
                                      icon: "",
                                      imgSrc:
                                        "assets/dashboard/menu/" +
                                        mt_element.meterType +
                                        ext,
                                      level: "device",
                                      key: mt_element.deviceID,
                                      deviceType: mt_element.deviceType,
                                      meterType: mt_element.meterType,
                                      deviceVersion: mt_element.version,
                                      isActive:mt_element.isActive
                                    });
                                  }
                                );
                              }

                              let meteringPoint: SideNavItem = {
                                type: "account",
                                icon: "",
                                imgSrc:
                                  this.companyCheck == "landis"
                                    ? "assets/landis-assets/images/verticalbuilding.svg"
                                    : "assets/dashboard/menu/vertical-building.svg",
                                text: mp_element.meteringPointName,
                                submenu: deviceArr,
                                key: mp_element.meteringPointID,
                                level: "meteringPoint",
                              };
                              meteringPoints.push(meteringPoint);
                              // this.changeDetectorRef.detectChanges();
                              if (mp_index === mp_array.length - 1) {
                                this.changeDetectorRef.markForCheck();
                              }
                              mp_index = mp_index + 1;
                            }
                          );
                        }
                      }, 1000);

                      let meteringSectionAllUsers: SideNavItem = {
                        type: "account",
                        icon: "",
                        userAccount: "yes",
                        pmLevel: "all",
                        imgSrc: this.companyCheck == "landis"
                        ? "assets/landis-assets/images/landisUserAll.png"
                        : "assets/dashboard/menu/userAll.png",
                        text: "All Accounts",
                        textLevel: ms_element.meteringSectionName,
                        submenu: [],
                        key: ms_element.meteringSectionID,
                        level: "meteringSection",
                      };
                      meteringPoints.push(meteringSectionAllUsers);

                      let meteringSectionAdminUsers: SideNavItem = {
                        type: "account",
                        icon: "",
                        userAccount: "yes",
                        pmLevel: "2",
                        imgSrc: this.companyCheck == "landis"
                        ? "assets/landis-assets/images/landisUserAdmin.png"
                        : "assets/dashboard/menu/userAdmin.png",
                        text: "Managers Only",
                        textLevel: ms_element.meteringSectionName,
                        submenu: [],
                        key: ms_element.meteringSectionID,
                        level: "meteringSection",
                      };
                      meteringPoints.push(meteringSectionAdminUsers);

                      let meteringSection: SideNavItem = {
                        type: "account",
                        icon: "",
                        imgSrc:
                          this.companyCheck == "landis"
                            ? "assets/landis-assets/images/meteringsectionicon.svg"
                            : "assets/dashboard/menu/building.svg",
                        text: ms_element.meteringSectionName,
                        submenu: meteringPoints,
                        key: ms_element.meteringSectionID,
                        level: "meteringSection",
                      };
                      meteringSections.push(meteringSection);

                      // this.changeDetectorRef.detectChanges();
                      if (ms_index === ms_array.length - 1) {
                        this.changeDetectorRef.markForCheck();
                      }
                      ms_index = ms_index + 1;
                    }
                  );
                }

                // adding value 1st child
                let dataitem: SideNavItems = {
                  [element.meteringFarmID]: {
                    type: "account",
                    icon: "",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/meteringfarm.svg"
                        : "assets/dashboard/menu/tree.svg",
                    text: element.meteringFarmName,
                    submenu: meteringSections,
                    key: element.meteringFarmID,
                    level: "meteringFarm",
                  },
                };

                sideNavItemsList.AddData(dataitem);
                this.changeDetectorRef.detectChanges();
              });
            }

            if (
              data.data.meteringSections &&
              data.data.meteringSections.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringSections.forEach(
                (ms_element: any, ms_index: any, ms_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = ms_element.meteringSectionID;
                  _keyValue.value = ms_element.meteringSectionName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let meteringPoints: any = [];

                  setTimeout(() => {
                    if (
                      ms_element.meteringPoints &&
                      ms_element.meteringPoints.length > 0 &&
                      this.meteringPointManagement != "no-access"
                    ) {
                      ms_element.meteringPoints.forEach(
                        (mp_element: any, mp_index: any, mp_array: any[]) => {
                          let deviceArr: any = [];

                          if (
                            mp_element.meters &&
                            mp_element.meters.length > 0 &&
                            this.deviceManagement != "no-access"
                          ) {
                            mp_element.meters.forEach(
                              (
                                mt_element: any,
                                mt_index: any,
                                mt_array: any[]
                              ) => {
                                // deviceArr.push({
                                //     type: 'account',
                                //     text: mt_element.deviceName,
                                //     icon: '',
                                //     imgSrc: 'assets/dashboard/menu/' + mt_element.meterType + '.svg',
                                //     level: "device",
                                //     key: mt_element.deviceID,
                                //     deviceType: mt_element.deviceType,
                                //     meterType: mt_element.meterType,
                                // })
                              }
                            );
                          }

                          let meteringPoint: SideNavItem = {
                            type: "account",
                            icon: "",
                            imgSrc:
                              this.companyCheck == "landis"
                                ? "assets/landis-assets/images/verticalbuilding.svg"
                                : "assets/dashboard/menu/vertical-building.svg",
                            text: mp_element.meteringPointName,
                            submenu: deviceArr,
                            key: mp_element.meteringPointID,
                            level: "meteringPoint",
                          };
                          meteringPoints.push(meteringPoint);
                          // this.changeDetectorRef.detectChanges();
                          if (mp_index === mp_array.length - 1) {
                            this.changeDetectorRef.markForCheck();
                          }
                          mp_index = mp_index + 1;
                        }
                      );
                    }
                  }, 1000);

                  let meteringSectionAllUsers: SideNavItem = {
                    type: "account",
                    icon: "",
                    userAccount: "yes",
                    pmLevel: "all",
                    imgSrc: this.companyCheck == "landis"
                    ? "assets/landis-assets/images/landisUserAll.png"
                    : "assets/dashboard/menu/userAll.png",
                    text: "All Accounts",
                    textLevel: ms_element.meteringSectionName,
                    submenu: [],
                    key: ms_element.meteringSectionID,
                    level: "meteringSection",
                  };
                  meteringPoints.push(meteringSectionAllUsers);

                  let meteringSectionAdminUsers: SideNavItem = {
                    type: "account",
                    icon: "",
                    userAccount: "yes",
                    pmLevel: "2",
                    imgSrc: this.companyCheck == "landis"
                    ? "assets/landis-assets/images/landisUserAdmin.png"
                    : "assets/dashboard/menu/userAdmin.png",
                    text: "Managers Only",
                    textLevel: ms_element.meteringSectionName,
                    submenu: [],
                    key: ms_element.meteringSectionID,
                    level: "meteringSection",
                  };
                  meteringPoints.push(meteringSectionAdminUsers);

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [ms_element.meteringSectionID]: {
                      type: "account",
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: ms_element.meteringSectionName,
                      submenu: meteringPoints,
                      key: ms_element.meteringSectionID,
                      level: "meteringSection",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            if (
              data.data.meteringPoints &&
              data.data.meteringPoints.length > 0 &&
              this.meteringPointManagement != "no-access"
            ) {
              data.data.meteringPoints.forEach(
                (mp_element: any, mp_index: any, mp_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = mp_element.meteringPointID;
                  _keyValue.value = mp_element.meteringPointName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let deviceArr: any = [];

                  setTimeout(() => {
                    if (
                      mp_element.meters &&
                      mp_element.meters.length > 0 &&
                      this.deviceManagement != "no-access"
                    ) {
                      mp_element.meters.forEach(
                        (mt_element: any, mt_index: any, mt_array: any[]) => {
                          let ext = ".svg";
                          if (
                            mt_element.meterType != "water" &&
                            mt_element.meterType != "electricity" &&
                            mt_element.meterType != "gas"
                          )
                            ext = ".png";
                          deviceArr.push({
                            type: "account",
                            text: mt_element.deviceName,
                            icon: "",
                            imgSrc:
                              "assets/dashboard/menu/" +
                              mt_element.meterType +
                              ext,
                            level: "device",
                            key: mt_element.deviceID,
                            deviceType: mt_element.deviceType,
                            meterType: mt_element.meterType,
                            deviceVersion: mt_element.version,
                            isActive:mt_element.isActive
                          });
                        }
                      );
                    }
                  }, 1000);

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [mp_element.meteringPointID]: {
                      type: "account",
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: mp_element.meteringPointName,
                      submenu: deviceArr,
                      key: mp_element.meteringPointID,
                      level: "meteringPoint",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }
            localStorage.setItem("menuLoaded", "yes");
            this.reloadNav = "yes";
            this.changeDetectorRef.detectChanges();
            this.changeDetectorRef.markForCheck();
            localStorage.setItem("reload", "no");
          }
        },
       async (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 10000,
          };
          // Keep session intact on hierarchy load failures.
          console.log(error);
          let message = "";
          if (error && error.error && Array.isArray(error.error.data)) {
            for (var i = 0; i < error.error.data.length; i++) {
              message += error.error.data[i] + "\n";
            }
            this.toastService.show("No Devices", error.error.data, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else if (error && error.error && typeof error.error.data === "string") {
            message = error.error.data;
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else if (error && error.message) {
            message = error.message;
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else {
            message = "An unknown error occurred.";
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          }
          return;
        }
      );
  }

  closeSideNavIfOpen() {
    const BOOTSTRAP_LG_WIDTH = 992;
    if (this.utilityService.window.innerWidth >= 992) {
      return;
    }
    // After the lg breakpoint, hidden is actually visible.
    // So the toggleSideNav below only will fire if the screen is < 992px
    // and the sideNav is open.
    if (this.sideNavHidden) {
      this.navigationService.toggleSideNav(true);
    }
  }

  async mainDashNav(option: string) {
    this.dashboard = "";
    this.reporting = "";
    this.users = "";
    this.notifications = "";
    this.tariff = "";
    this.alert = "";
    this.diagnostics = "";
    this.geolocation = "";

    localStorage.setItem("menuIsReset", "no");
    localStorage.setItem("reload", "no");

    if (localStorage.getItem("active") == "users" && option != "users") {
      //localStorage.setItem("reload", "yes");
    }
    if (localStorage.getItem("active") != "users" && option == "users") {
      //localStorage.setItem("reload", "yes");
    }
    localStorage.setItem("active", "");

    if (option == "dashboard") {
      localStorage.setItem("activeLevel", "meteringSection");

      localStorage.setItem("active", "dashboard");
      this.dashboard = "active-item";
      this.navigationService.router.navigateByUrl("/dashboard");
    }
    if (option == "reporting") {
      localStorage.setItem("active", "reporting");
      this.reporting = "active-item";
      this.navigationService.router.navigateByUrl("/dashboard/reporting");
    }
    if (option == "users") {
      if (localStorage.getItem("meteringFarmID")) {
        localStorage.setItem("activeLevel", "meteringFarm");
      } else if (localStorage.getItem("meteringSectionID")) {
        localStorage.setItem("activeLevel", "meteringSection");
      } else if (localStorage.getItem("meteringPointID")) {
        localStorage.setItem("activeLevel", "meteringPoint");
      }
      localStorage.setItem("active", "users");

      this.users = "active-item";
      this.navigationService.router.navigateByUrl("/dashboard/users");
    }
    if (option == "notifications") {
      localStorage.setItem("active", "notifications");
      this.notifications = "active-item";
      if (parseInt(this.pmLevel) === 1) {
        // this.navigationService.router.navigateByUrl(
        //   "/dashboard/notifications/meteringFarms"
        // );

         this.navigationService.router.navigateByUrl(
          "/dashboard/notifications/meteringFarms"
        );
      }
      if (parseInt(this.pmLevel) === 2) {
        this.navigationService.router.navigateByUrl(
          "/dashboard/notifications/meteringSections"
        );
      }
      if (parseInt(this.pmLevel) === 3) {
        this.navigationService.router.navigateByUrl(
          "/dashboard/notifications/meteringPoints"
        );
      }
    }
    if (option == "tariff") {
      localStorage.setItem("active", "tariff");
      this.tariff = "active-item";
      this.navigationService.router.navigateByUrl("/dashboard/tariff/myTariff");
    }
    if (option == "alerts") {
      localStorage.setItem("active", "alerts");
      this.alert = "active-item";
      this.navigationService.router.navigateByUrl(
        "/dashboard/notifications/alerts"
      );
    }
    if (option == "integration") {
      localStorage.setItem("active", "integration");
      this.integration = "active-item";
      this.navigationService.router.navigateByUrl(
        "/dashboard/integration/list"
      );
    }
    if (option == "formsConfiguration") {
      localStorage.setItem("active", "formsConfiguration");
      this.formsConfiguration = "active-item";
      this.navigationService.router.navigateByUrl(
        "/dashboard/metering/formsConfiguration"
      );
    }
    if (option == "diagnostics") {
      localStorage.setItem("active", "diagnostics");
      this.diagnostics = "active-item";
      this.navigationService.router.navigateByUrl(
        "/dashboard/diagnostics"
      );
    }
    if (option == "geolocation") {
      localStorage.setItem("active", "geolocation");
      this.geolocation = "active-item";
      this.navigationService.router.navigateByUrl(
        "/dashboard/diagnostics/geolocation"
      );
    }
    if (option == "jobbox") {
      // this.jobbox = "active-item";
      const email = await this.secureStorage.getItem('email');
      if (localStorage.getItem("userID") && email) {
        //open jobbox platform
        let environment: any = localStorage.getItem("environment");
        let userID: any = localStorage.getItem("userID");
        let userEmail: any = email;
        let encodedUserID = Buffer.from(userID, "binary").toString("base64");
        let encodedUserEmail = Buffer.from(userEmail, "binary").toString(
          "base64"
        );

        if (
          localStorage.getItem("environment") &&
          (localStorage.getItem("environment") == "production" ||
            localStorage.getItem("environment") == "prod")
        ) {
          window.open(
            "https://job-box.smartviewtechnology.co.za/autologin/" +
              encodedUserID +
              "/" +
              encodedUserEmail,
            "_blank"
          );
        } else {
          window.open(
            "https://" +
              environment +
              "-dot-smart-view-job-box.ew.r.appspot.com/autologin/" +
              encodedUserID +
              "/" +
              encodedUserEmail,
            "_blank"
          );
        }
      }
    }
  }





    async LoadMeteringHeirachy() {
   
    if(this.unapprovedRegisteredUser == 'true'){
      return
    }


    let permissions:any = this.permissionsService.getAll();
    // let permissions:any = await this.secureStorage.getItem('permissions');
    // permissions =  JSON.parse(permissions);

    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest.apiRequest("metering/metering_hierarchy/","metering_hierarchy.json",
        body
      )
      .subscribe(
        (data) => {
          if (data.success == true) {
            this.sideNavSections[0].items = [];
            if (
              data.data.meteringFarms &&
              data.data.meteringFarms.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringFarms.forEach((element: any) => {
                // adding value to parent menu
                let _keyValue: keyvalue = {} as keyvalue;
                _keyValue.key = element.meteringFarmID;
                _keyValue.value = element.meteringFarmName;
                this.sideNavSections[0].items.push(_keyValue);
                let meteringSections: any = [];

                //   element.meteringSections &&
                //   element.meteringSections.length > 0 &&
                //   this.meteringSectionManagement != "no-access"
                // ) {
                //   element.meteringSections.forEach(
                //     (ms_element: any, ms_index: any, ms_array: any[]) => {

                //       let meteringPoints: any = [];

                //       //Add for each metering section
                //       let meteringPoint = {
                //         type: "modems",
                //         icon: "",
                //         userAccount: "yes",
                //         imgSrc:
                //           this.companyCheck == "landis"
                //             ? "assets/landis-assets/images/modems.png"
                //             : "assets/dashboard/menu/modem.png",
                //         text: "Modems/Gateways",
                //         key: ms_element.meteringSectionID,
                //         level: "modems",
                //       };
                //       meteringPoints.push(meteringPoint);

                //       setTimeout(() => {
                //         if (
                //           ms_element.meteringPoints &&
                //           ms_element.meteringPoints.length > 0 &&
                //           this.meteringPointManagement != "no-access"
                //         ) {
                //           ms_element.meteringPoints.forEach(
                //             (
                //               mp_element: any,
                //               mp_index: any,
                //               mp_array: any[]
                //             ) => {
                //               let deviceArr: any = [];
                //               if (
                //                 mp_element.meters &&
                //                 mp_element.meters.length > 0 &&
                //                 this.deviceManagement != "no-access"
                //               ) {

                //                 //only display for where there is meters
                              

                                
                //                 if(mp_element.thinPrepaymentStatus == 'enabled'){
                //                   deviceArr.push({
                //                     type: "wallet",
                //                     icon: "",
                //                     userAccount: "yes",
                //                     imgSrc: "assets/dashboard/wallet.png",
                //                     text: "Wallet Dashboard",
                //                     key: mp_element.meteringPointID,
                //                     level: "wallet",
                //                   });
                //                 }else{
                //                   deviceArr.push({
                //                     type: "statement",
                //                     icon: "",
                //                     userAccount: "yes",
                //                     imgSrc: "assets/dashboard/menu/doc.png",
                //                     text: "View Statement",
                //                     key: mp_element.meteringPointID,
                //                     level: "statement",
                //                   });
                //                 }
                               
                               
                               

                //                 mp_element.meters.forEach(
                //                   (
                //                     mt_element: any,
                //                     mt_index: any,
                //                     mt_array: any[]
                //                   ) => {
                //                     let ext = ".svg";
                //                     if (
                //                       mt_element.meterType != "water" &&
                //                       mt_element.meterType != "electricity" &&
                //                       mt_element.meterType != "gas"
                //                     )
                //                       ext = ".png";
                //                     deviceArr.push({
                //                       type: "",
                //                       text: mt_element.deviceName,
                //                       icon: "",
                //                       imgSrc:
                //                         "assets/dashboard/menu/" +
                //                         mt_element.meterType +
                //                         ext,
                //                       level: "device",
                //                       key: mt_element.deviceID,
                //                       deviceType: mt_element.deviceType,
                //                       meterType: mt_element.meterType,
                //                       deviceVersion: mt_element.version,
                //                       isActive:mt_element.isActive
                //                     });
                //                   }
                                  
                //                 );

                               
                //               }

                //               let meteringPoint: SideNavItem = {
                //                 icon: "",
                //                 imgSrc:
                //                   this.companyCheck == "landis"
                //                     ? "assets/landis-assets/images/verticalbuilding.svg"
                //                     : "assets/dashboard/menu/vertical-building.svg",
                //                 text: mp_element.meteringPointName,
                //                 totalMeters: mp_element.totalMeters,
                //                 submenu: deviceArr,
                //                 key: mp_element.meteringPointID,
                //                 level: "meteringPoint",
                //               };
                //               meteringPoints.push(meteringPoint);
                //               // this.changeDetectorRef.detectChanges();
                //               if (mp_index === mp_array.length - 1) {
                //                 this.changeDetectorRef.markForCheck();
                //               }
                //               mp_index = mp_index + 1;
                //             }
                //           );
                //         }
                //       }, 1000);

                //       let meteringSection: SideNavItem = {
                //         icon: "",
                //         imgSrc:
                //           this.companyCheck == "landis"
                //             ? "assets/landis-assets/images/meteringsectionicon.svg"
                //             : "assets/dashboard/menu/building.svg",
                //         text: ms_element.meteringSectionName,
                //         submenu: meteringPoints,
                //         key: ms_element.meteringSectionID,
                //         level: "meteringSection",
                //       };
                //       meteringSections.push(meteringSection);
                //       // this.changeDetectorRef.detectChanges();
                //       if (ms_index === ms_array.length - 1) {
                //         this.changeDetectorRef.markForCheck();
                //       }
                //       ms_index = ms_index + 1;
                //     }
                //   );
                // }

                // adding value 1st child
                let dataitem: SideNavItems = {
                  [element.meteringFarmID]: {
                    icon: "",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/meteringfarm.svg"
                        : "assets/dashboard/menu/tree.svg",
                    text: element.meteringFarmName,
                    submenu: meteringSections,
                    key: element.meteringFarmID,
                    level: "meteringFarm",
                  },
                };

                sideNavItemsList.AddData(dataitem);
                this.changeDetectorRef.detectChanges();
              });
            }

            if (
              data.data.meteringSections &&
              data.data.meteringSections.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringSections.forEach(
                (ms_element: any, ms_index: any, ms_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = ms_element.meteringSectionID;
                  _keyValue.value = ms_element.meteringSectionName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let meteringPoints: any = [];

                  // let meteringPoint = {
                  //   type: "modems",
                  //   icon: "",
                  //   userAccount: "yes",
                  //   imgSrc:
                  //     this.companyCheck == "landis"
                  //       ? "assets/landis-assets/images/modems.png"
                  //       : "assets/dashboard/menu/modem.png",
                  //   text: "Modems/Gateways",
                  //   key: ms_element.meteringSectionID,
                  //   level: "modems",
                  // };
                  // meteringPoints.push(meteringPoint);

                  // setTimeout(() => {
                  //   if (
                  //     ms_element.meteringPoints &&
                  //     ms_element.meteringPoints.length > 0 &&
                  //     this.meteringPointManagement != "no-access"
                  //   ) {
                  //     ms_element.meteringPoints.forEach(
                  //       (mp_element: any, mp_index: any, mp_array: any[]) => {
                  //         let deviceArr: any = [];

                  //         if (
                  //           mp_element.meters &&
                  //           mp_element.meters.length > 0 &&
                  //           this.deviceManagement != "no-access"
                  //         ) {
                  //           //only display for where there is meters
                          

                  //           if(mp_element.thinPrepaymentStatus == 'enabled'){
                  //             deviceArr.push({
                  //               type: "wallet",
                  //               icon: "",
                  //               userAccount: "yes",
                  //               imgSrc: "assets/dashboard/wallet.png",
                  //               text: "Wallet Dashboard",
                  //               key: mp_element.meteringPointID,
                  //               level: "wallet",
                  //             });
                  //           }else{
                  //             deviceArr.push({
                  //               type: "statement",
                  //               icon: "",
                  //               userAccount: "yes",
                  //               imgSrc: "assets/dashboard/menu/doc.png",
                  //               text: "View Statement",
                  //               key: mp_element.meteringPointID,
                  //               level: "statement",
                  //             });
                  //           }

                          

                           

                  //           mp_element.meters.forEach(
                  //             (
                  //               mt_element: any,
                  //               mt_index: any,
                  //               mt_array: any[]
                  //             ) => {
                  //               let ext = ".svg";
                  //               if (
                  //                 mt_element.meterType != "water" &&
                  //                 mt_element.meterType != "electricity" &&
                  //                 mt_element.meterType != "gas"
                  //               )
                  //                 ext = ".png";
                  //               deviceArr.push({
                  //                 type: "",
                  //                 text: mt_element.deviceName,
                  //                 icon: "",
                  //                 imgSrc:
                  //                   "assets/dashboard/menu/" +
                  //                   mt_element.meterType +
                  //                   ext,
                  //                 level: "device",
                  //                 key: mt_element.deviceID,
                  //                 deviceType: mt_element.deviceType,
                  //                 meterType: mt_element.meterType,
                  //                 deviceVersion: mt_element.version,
                  //                 isActive:mt_element.isActive
                  //               });
                  //             }
                  //           );
                           
                  //         }

                  //         let meteringPoint: SideNavItem = {
                  //           icon: "",
                  //           imgSrc:
                  //             this.companyCheck == "landis"
                  //               ? "assets/landis-assets/images/verticalbuilding.svg"
                  //               : "assets/dashboard/menu/vertical-building.svg",
                  //           text: mp_element.meteringPointName,
                  //           totalMeters: mp_element.totalMeters,
                  //           submenu: deviceArr,
                  //           key: mp_element.meteringPointID,
                  //           level: "meteringPoint",
                  //         };
                  //         meteringPoints.push(meteringPoint);
                  //         // this.changeDetectorRef.detectChanges();
                  //         // if (mp_index === mp_array.length - 1) {
                  //         //   this.changeDetectorRef.markForCheck();
                  //         // }
                  //         // mp_index = mp_index + 1;
                  //       }
                  //     );
                  //   }
                  // }, 1000);

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [ms_element.meteringSectionID]: {
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: ms_element.meteringSectionName,
                      submenu: meteringPoints,
                      key: ms_element.meteringSectionID,
                      level: "meteringSection",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            if (
              data.data.meteringPoints &&
              data.data.meteringPoints.length > 0 &&
              this.meteringPointManagement != "no-access"
            ) {
              data.data.meteringPoints.forEach(
                (mp_element: any, mp_index: any, mp_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = mp_element.meteringPointID;
                  (_keyValue.value = mp_element.meteringPointName),
                    (_keyValue.totalMeters = mp_element.totalMeters),
                    this.sideNavSections[0].items.push(_keyValue);

                  let deviceArr: any = [];

                  //   if (
                  //     mp_element.meters &&
                  //     mp_element.meters.length > 0 &&
                  //     this.deviceManagement != "no-access"
                  //   ) {
                  //     //only display for where there is meters
                   
                      
                  //      if(mp_element.thinPrepaymentStatus == 'enabled'){
                  //       deviceArr.push({
                  //         type: "wallet",
                  //         icon: "",
                  //         userAccount: "yes",
                  //         imgSrc: "assets/dashboard/wallet.png",
                  //         text: "Wallet Dashboard",
                  //         key: mp_element.meteringPointID,
                  //         level: "wallet",
                  //       });
                  //      }else{
                  //       deviceArr.push({
                  //         type: "statement",
                  //         icon: "",
                  //         userAccount: "yes",
                  //         imgSrc: "assets/dashboard/menu/doc.png",
                  //         text: "View Statement",
                  //         key: mp_element.meteringPointID,
                  //         level: "statement",
                  //       });
                  //      }

                  //     mp_element.meters.forEach(
                  //       (mt_element: any, mt_index: any, mt_array: any[]) => {
                  //         let ext = ".svg";
                  //         if (
                  //           mt_element.meterType != "water" &&
                  //           mt_element.meterType != "electricity" &&
                  //           mt_element.meterType != "gas"
                  //         )
                  //           ext = ".png";
                  //         deviceArr.push({
                  //           type: "",
                  //           text: mt_element.deviceName,
                  //           icon: "",
                  //           imgSrc:
                  //             "assets/dashboard/menu/" +
                  //             mt_element.meterType +
                  //             ext,
                  //           level: "device",
                  //           key: mt_element.deviceID,
                  //           deviceType: mt_element.deviceType,
                  //           meterType: mt_element.meterType,
                  //           deviceVersion: mt_element.version,
                  //           isActive:mt_element.isActive
                  //         });
                  //       }
                  //     );
                    
                  //   }
                  // }, 1000);

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [mp_element.meteringPointID]: {
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: mp_element.meteringPointName,
                      totalMeters: mp_element.totalMeters,
                      submenu: deviceArr,
                      key: mp_element.meteringPointID,
                      level: "meteringPoint",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            localStorage.setItem("menuLoaded", "yes");
            this.reloadNav = "yes";
            this.changeDetectorRef.detectChanges();
            this.changeDetectorRef.markForCheck();
            localStorage.setItem("reload", "no");
          }
        },
        async (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 10000,
          };
          // Keep session intact on hierarchy load failures.
          console.log(error);
          let message = "";
          if (error && error.error && Array.isArray(error.error.data)) {
            for (var i = 0; i < error.error.data.length; i++) {
              message += error.error.data[i] + "\n";
            }
            this.toastService.show("No Devices", error.error.data, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else if (error && error.error && typeof error.error.data === "string") {
            message = error.error.data;
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else if (error && error.message) {
            message = error.message;
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else {
            message = "An unknown error occurred.";
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          }
          return;
        }
      );
  }



    async LoadAccountHeirachy() {

    let permissions:any = this.permissionsService.getAll();
    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    this.apiRequest
      .apiRequest("metering/account_hierarchy/", "account_hierarchy.json", body)
      .subscribe(
        (data) => {
          if (data.success == true) {
            console.log("Save json account_hierarchy");
            this.sideNavSections[0].items = [];
            if (
              data.data.meteringFarms &&
              data.data.meteringFarms.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
             
              data.data.meteringFarms.forEach((element: any) => {
                // adding value to parent menu
                let _keyValue: keyvalue = {} as keyvalue;
                _keyValue.key = element.meteringFarmID;
                _keyValue.value = element.meteringFarmName;
                this.sideNavSections[0].items.push(_keyValue);
                let meteringSections: any = [];

                // adding value 1st child
                let dataitem: SideNavItems = {
                  [element.meteringFarmID]: {
                    type: "account",
                    pmLevel:'all',
                    icon: "",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/meteringfarm.svg"
                        : "assets/dashboard/menu/tree.svg",
                    text: element.meteringFarmName,
                    submenu: meteringSections,
                    key: element.meteringFarmID,
                    level: "meteringFarm",
                  },
                };

                sideNavItemsList.AddData(dataitem);
                this.changeDetectorRef.detectChanges();
              });
            }

            if (
              data.data.meteringSections &&
              data.data.meteringSections.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringSections.forEach(
                (ms_element: any, ms_index: any, ms_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = ms_element.meteringSectionID;
                  _keyValue.value = ms_element.meteringSectionName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let meteringPoints: any = [];
                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [ms_element.meteringSectionID]: {
                      type: "account",
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: ms_element.meteringSectionName,
                      submenu: meteringPoints,
                      key: ms_element.meteringSectionID,
                      level: "meteringSection",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            if (
              data.data.meteringPoints &&
              data.data.meteringPoints.length > 0 &&
              this.meteringPointManagement != "no-access"
            ) {
              data.data.meteringPoints.forEach(
                (mp_element: any, mp_index: any, mp_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = mp_element.meteringPointID;
                  _keyValue.value = mp_element.meteringPointName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let deviceArr: any = [];
                  
                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [mp_element.meteringPointID]: {
                      type: "account",
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: mp_element.meteringPointName,
                      submenu: deviceArr,
                      key: mp_element.meteringPointID,
                      level: "meteringPoint",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }
            localStorage.setItem("menuLoaded", "yes");
            this.reloadNav = "yes";
            this.changeDetectorRef.detectChanges();
            this.changeDetectorRef.markForCheck();
            localStorage.setItem("reload", "no");
          }
        },
       async (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 10000,
          };
          // Keep session intact on hierarchy load failures.
          console.log(error);
          let message = "";
          for (var i = 0; i < error.error.data.length; i++) {
            message += error.error.data[i] + "\n";
          }
          this.toastService.show("No Devices", error.error.data, {
            headerClasses: "bg-danger text-light",
            ...defaultOptions,
          });
          return;
        }
      );
  }



  async getInitialNavigationMenuData(searchTerm?: string) {
   localStorage.setItem("navFarmsPage","1");
    // Clear per-section, per-point, and per-meter pagination keys at init
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i) as string;
      if (k && (k.indexOf("navChildrenPointsPage:") === 0 || k.indexOf("navChildrenSectionPage:") === 0 || k.indexOf("navChildrenMetersPage:") === 0)) {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach(k => localStorage.removeItem(k));
    if(this.unapprovedRegisteredUser == 'true'){
      return
    }


    let permissions:any = this.permissionsService.getAll();
    // let permissions:any = await this.secureStorage.getItem('permissions');
    // permissions =  JSON.parse(permissions);

    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
        perPage:5,
        page:1,
        searchTerm: (typeof searchTerm === 'string' ? searchTerm : undefined)
      },
    };

    if(searchTerm == null || searchTerm == '' || searchTerm == undefined ){
      delete body.payload.searchTerm
    }

    this.navigationLoadSub = this.apiRequest.apiRequest("metering/navigation/children/","children.json",
        body
      )
      .subscribe(
        (data) => {
          if (data.success == true) {
            this.sideNavSections[0].items = [];
            console.log(data.data.data)
            if (
              data.data.data &&
              data.data.data.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.data.forEach((element: any) => {
                // adding value to parent menu
                let _keyValue: keyvalue = {} as keyvalue;
                _keyValue.key = element.id;
                _keyValue.value = element.name;
                this.sideNavSections[0].items.push(_keyValue);
                let meteringSections: any = [];

                // adding value 1st child
                let dataitem: SideNavItems = {
                  [element.id]: {
                    icon: "",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/meteringfarm.svg"
                        : "assets/dashboard/menu/tree.svg",
                    text: element.name,
                    submenu: meteringSections,
                    key: element.id,
                    level: "meteringFarm",
                  },
                };

                sideNavItemsList.AddData(dataitem);
                this.changeDetectorRef.detectChanges();
              });

              // Append a virtual "Load more" item at the end for pagination in the side item component
              const hasLoadMore = this.sideNavSections[0].items.some((it: any) => it.key === -1);
              // Add load more entry only if there are items and we don't already have one
              if (data.data.pagination.next != null) {
                this.sideNavSections[0].items.push({ key: -1, value: 'Load more farms', totalMeters: 0 } as any);
                sideNavItemsList.AddData({
                  [-1]: {
                    icon: '',
                    imgSrc: '',
                    text: 'Load more farms',
                    submenu: [],
                    key: -1,
                    level: 'loadMoreFarms',
                  },
                });
              }
            }

            if (
              data.data.meteringSections &&
              data.data.meteringSections.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringSections.forEach(
                (ms_element: any, ms_index: any, ms_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = ms_element.meteringSectionID;
                  _keyValue.value = ms_element.meteringSectionName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let meteringPoints: any = [];

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [ms_element.meteringSectionID]: {
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: ms_element.meteringSectionName,
                      submenu: meteringPoints,
                      key: ms_element.meteringSectionID,
                      level: "meteringSection",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            if (
              data.data.meteringPoints &&
              data.data.meteringPoints.length > 0 &&
              this.meteringPointManagement != "no-access"
            ) {
              data.data.meteringPoints.forEach(
                (mp_element: any, mp_index: any, mp_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = mp_element.meteringPointID;
                  (_keyValue.value = mp_element.meteringPointName),
                    (_keyValue.totalMeters = mp_element.totalMeters),
                    this.sideNavSections[0].items.push(_keyValue);

                  let deviceArr: any = [];

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [mp_element.meteringPointID]: {
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: mp_element.meteringPointName,
                      totalMeters: mp_element.totalMeters,
                      submenu: deviceArr,
                      key: mp_element.meteringPointID,
                      level: "meteringPoint",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            localStorage.setItem("menuLoaded", "yes");
            this.reloadNav = "yes";
            this.changeDetectorRef.detectChanges();
            this.changeDetectorRef.markForCheck();
            localStorage.setItem("reload", "no");
          }
        },
        async (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 10000,
          };
          // Keep session intact on hierarchy load failures.
          console.log(error);
          let message = "";
          if (error && error.error && Array.isArray(error.error.data)) {
            for (var i = 0; i < error.error.data.length; i++) {
              message += error.error.data[i] + "\n";
            }
            this.toastService.show("No Devices", error.error.data, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else if (error && error.error && typeof error.error.data === "string") {
            message = error.error.data;
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else if (error && error.message) {
            message = error.message;
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else {
            message = "An unknown error occurred.";
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          }
          return;
        }
      );
  }

  onMenuSearch(term: string) {
    this.latestSearchTerm = term || '';
    this.getInitialNavigationMenuData(this.latestSearchTerm);
  }

  


  
    async getInitialNavigationMenuDataAccounts() {
    localStorage.setItem("navFarmsPage","1");
    let permissions:any = this.permissionsService.getAll();
    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
        perPage:100,
        page:1
      },
    };

    this.apiRequest
      .apiRequest("metering/navigation/children/","children.json", body)
      .subscribe(
        (data) => {
          if (data.success == true) {
            console.log("Save json account_hierarchy");
            this.sideNavSections[0].items = [];
            if (
              data.data.data &&
              data.data.data.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
             
              data.data.data.forEach((element: any) => {
                // adding value to parent menu
                let _keyValue: keyvalue = {} as keyvalue;
                _keyValue.key = element.id;
                _keyValue.value = element.name;
                this.sideNavSections[0].items.push(_keyValue);
                let meteringSections: any = [];

                // adding value 1st child
                let dataitem: SideNavItems = {
                  [element.id]: {
                    type: "account",
                    pmLevel:'all',
                    icon: "",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/meteringfarm.svg"
                        : "assets/dashboard/menu/tree.svg",
                    text: element.name,
                    submenu: meteringSections,
                    key: element.id,
                    level: "meteringFarm",
                  },
                };

                sideNavItemsList.AddData(dataitem);
                this.changeDetectorRef.detectChanges();
              });


              // Append a virtual "Load more" item at the end for pagination in the side item component
              const hasLoadMore = this.sideNavSections[0].items.some((it: any) => it.key === -1);
              // Add load more entry only if there are items and we don't already have one
              if (data.data.data.length > 0 && !hasLoadMore) {
                this.sideNavSections[0].items.push({ key: -1, value: 'Load more farms', totalMeters: 0 } as any);
                sideNavItemsList.AddData({
                  [-1]: {
                    icon: '',
                    imgSrc: '',
                    text: 'Load more farms',
                    submenu: [],
                    key: -1,
                    level: 'loadMoreFarms',
                  },
                });
              }


            }
            

            if (
              data.data.meteringSections &&
              data.data.meteringSections.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringSections.forEach(
                (ms_element: any, ms_index: any, ms_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = ms_element.meteringSectionID;
                  _keyValue.value = ms_element.meteringSectionName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let meteringPoints: any = [];
                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [ms_element.meteringSectionID]: {
                      type: "account",
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: ms_element.meteringSectionName,
                      submenu: meteringPoints,
                      key: ms_element.meteringSectionID,
                      level: "meteringSection",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            if (
              data.data.meteringPoints &&
              data.data.meteringPoints.length > 0 &&
              this.meteringPointManagement != "no-access"
            ) {
              data.data.meteringPoints.forEach(
                (mp_element: any, mp_index: any, mp_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = mp_element.meteringPointID;
                  _keyValue.value = mp_element.meteringPointName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let deviceArr: any = [];
                  
                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [mp_element.meteringPointID]: {
                      type: "account",
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: mp_element.meteringPointName,
                      submenu: deviceArr,
                      key: mp_element.meteringPointID,
                      level: "meteringPoint",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }
            localStorage.setItem("menuLoaded", "yes");
            this.reloadNav = "yes";
            this.changeDetectorRef.detectChanges();
            this.changeDetectorRef.markForCheck();
            localStorage.setItem("reload", "no");
          }
        },
       async (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 10000,
          };
          // Keep session intact on hierarchy load failures.
          console.log(error);
          let message = "";
          for (var i = 0; i < error.error.data.length; i++) {
            message += error.error.data[i] + "\n";
          }
          this.toastService.show("No Devices", error.error.data, {
            headerClasses: "bg-danger text-light",
            ...defaultOptions,
          });
          return;
        }
      );
  }


   async searchNavigationMenu(searchTerm?: string) {
   localStorage.setItem("navFarmsPage","1");
    // Clear per-section, per-point, and per-meter pagination keys at init
    const keysToRemove: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i) as string;
      if (k && (k.indexOf("navChildrenPointsPage:") === 0 || k.indexOf("navChildrenSectionPage:") === 0 || k.indexOf("navChildrenMetersPage:") === 0)) {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach(k => localStorage.removeItem(k));
    if(this.unapprovedRegisteredUser == 'true'){
      return
    }


    let permissions:any = this.permissionsService.getAll();
    // let permissions:any = await this.secureStorage.getItem('permissions');
    // permissions =  JSON.parse(permissions);

    this.deviceManagement = permissions.deviceManagement;
    this.meteringSectionManagement = permissions.meteringSectionManagement;
    this.meteringPointManagement = permissions.meteringPointManagement;

    let body: any = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
        perPage:5,
        page:1,
        searchTerm: (typeof searchTerm === 'string' ? searchTerm : undefined)
      },
    };

    if(searchTerm == null || searchTerm == '' || searchTerm == undefined ){
      delete body.payload.searchTerm
    }

    // Cancel previous in-flight request
    if (this.navigationLoadSub) {
      this.navigationLoadSub.unsubscribe();
    }

    this.navigationLoadSub = this.apiRequest.apiRequest("metering/navigation/children/","children.json",
        body
      )
      .subscribe(
        (data) => {
          if (data.success == true) {
            this.sideNavSections[0].items = [];
            console.log(data.data.data)
            if (
              data.data.data &&
              data.data.data.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.data.forEach((element: any) => {
                // adding value to parent menu
                let _keyValue: keyvalue = {} as keyvalue;
                _keyValue.key = element.id;
                _keyValue.value = element.name;
                this.sideNavSections[0].items.push(_keyValue);
                let meteringSections: any = [];

                // adding value 1st child
                let dataitem: SideNavItems = {
                  [element.id]: {
                    icon: "",
                    imgSrc:
                      this.companyCheck == "landis"
                        ? "assets/landis-assets/images/meteringfarm.svg"
                        : "assets/dashboard/menu/tree.svg",
                    text: element.name,
                    submenu: meteringSections,
                    key: element.id,
                    level: "meteringFarm",
                  },
                };

                sideNavItemsList.AddData(dataitem);
                this.changeDetectorRef.detectChanges();
              });

              // Append a virtual "Load more" item at the end for pagination in the side item component
              const hasLoadMore = this.sideNavSections[0].items.some((it: any) => it.key === -1);
              // Add load more entry only if there are items and we don't already have one
              if (data.data.pagination.next != null) {
                this.sideNavSections[0].items.push({ key: -1, value: 'Load more farms', totalMeters: 0 } as any);
                sideNavItemsList.AddData({
                  [-1]: {
                    icon: '',
                    imgSrc: '',
                    text: 'Load more farms',
                    submenu: [],
                    key: -1,
                    level: 'loadMoreFarms',
                  },
                });
              }
            }

            if (
              data.data.meteringSections &&
              data.data.meteringSections.length > 0 &&
              this.meteringSectionManagement != "no-access"
            ) {
              data.data.meteringSections.forEach(
                (ms_element: any, ms_index: any, ms_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = ms_element.meteringSectionID;
                  _keyValue.value = ms_element.meteringSectionName;
                  this.sideNavSections[0].items.push(_keyValue);

                  let meteringPoints: any = [];

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [ms_element.meteringSectionID]: {
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: ms_element.meteringSectionName,
                      submenu: meteringPoints,
                      key: ms_element.meteringSectionID,
                      level: "meteringSection",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            if (
              data.data.meteringPoints &&
              data.data.meteringPoints.length > 0 &&
              this.meteringPointManagement != "no-access"
            ) {
              data.data.meteringPoints.forEach(
                (mp_element: any, mp_index: any, mp_array: any[]) => {
                  // adding value to parent menu
                  let _keyValue: keyvalue = {} as keyvalue;
                  _keyValue.key = mp_element.meteringPointID;
                  (_keyValue.value = mp_element.meteringPointName),
                    (_keyValue.totalMeters = mp_element.totalMeters),
                    this.sideNavSections[0].items.push(_keyValue);

                  let deviceArr: any = [];

                  // adding value 1st child
                  let dataitem: SideNavItems = {
                    [mp_element.meteringPointID]: {
                      icon: "",
                      imgSrc:
                        this.companyCheck == "landis"
                          ? "assets/landis-assets/images/meteringsectionicon.svg"
                          : "assets/dashboard/menu/building.svg",
                      text: mp_element.meteringPointName,
                      totalMeters: mp_element.totalMeters,
                      submenu: deviceArr,
                      key: mp_element.meteringPointID,
                      level: "meteringPoint",
                    },
                  };

                  sideNavItemsList.AddData(dataitem);
                  this.changeDetectorRef.detectChanges();
                }
              );
            }

            localStorage.setItem("menuLoaded", "yes");
            this.reloadNav = "yes";
            this.changeDetectorRef.detectChanges();
            this.changeDetectorRef.markForCheck();
            localStorage.setItem("reload", "no");
          }
        },
        async (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 10000,
          };
          // Keep session intact on hierarchy load failures.
          console.log(error);
          let message = "";
          if (error && error.error && Array.isArray(error.error.data)) {
            for (var i = 0; i < error.error.data.length; i++) {
              message += error.error.data[i] + "\n";
            }
            this.toastService.show("No Devices", error.error.data, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else if (error && error.error && typeof error.error.data === "string") {
            message = error.error.data;
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else if (error && error.message) {
            message = error.message;
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          } else {
            message = "An unknown error occurred.";
            this.toastService.show("No Devices", message, {
              headerClasses: "bg-danger text-light",
              ...defaultOptions,
            });
          }
          return;
        }
      );
  }

  get canReviewPendingRates(): boolean {
    const pmLevelVal = parseInt(this.pmLevel || localStorage.getItem("pmLevel") || '0', 10);
    const tariffMgmt = this.tariffManagement || localStorage.getItem("tariffManagement") || '';
    const hasManagementPermission = tariffMgmt === 'admin' || tariffMgmt === 'creator' || tariffMgmt === 'editor';
    return this.isChannelPartner && pmLevelVal === 1 && hasManagementPermission;
  }

  get suppressPendingApprovals(): boolean {
    const pmLevelVal = parseInt(this.pmLevel || localStorage.getItem("pmLevel") || '0', 10);
    return pmLevelVal === 3 || this.isImpersonatingSession();
  }

  private isImpersonatingSession(): boolean {
    if (localStorage.getItem("impersination") === "yes") {
      return true;
    }

    const currentUserID = Number(localStorage.getItem("userID"));
    if (!Number.isInteger(currentUserID) || currentUserID <= 0) {
      return false;
    }

    return ["impersonatingUserID", "impersonateUserID"].some((key) => {
      const originalUserID = Number(localStorage.getItem(key));
      return Number.isInteger(originalUserID) && originalUserID > 0 && originalUserID !== currentUserID;
    });
  }

  private pendingApprovalsDismissedKey(userID: string): string {
    return `pendingApprovalsDismissed:${userID}`;
  }

  checkPendingApprovals(force = false) {
    const userIdStr = localStorage.getItem("userID");
    if (!userIdStr || this.mfaFlowActive || this.mfaPromptActive) return;
    if (this.suppressPendingApprovals) {
      this.pendingApprovalsData = null;
      this.showPendingApprovalsToast = false;
      return;
    }
    if (this.pendingApprovalsRequestInFlight) return;

    const dismissedKey = this.pendingApprovalsDismissedKey(userIdStr);
    if (!force && sessionStorage.getItem(dismissedKey) === 'true') {
      this.showPendingApprovalsToast = false;
      return;
    }

    const body = {
      payload: {
        userID: parseInt(userIdStr, 10)
      }
    };

    this.pendingApprovalsRequestInFlight = true;
    this.apiRequest.apiRequest("tariffs/pending_approval_counts/", "pending_approval_counts.json", body, { cancelable: false })
      .subscribe(
        res => {
          this.pendingApprovalsRequestInFlight = false;
          if (this.mfaFlowActive || this.mfaPromptActive || this.suppressPendingApprovals) {
            this.pendingApprovalsData = null;
            this.showPendingApprovalsToast = false;
            return;
          }
          if (res && res.success && res.data) {
            const data = res.data;
            if (data.hasPendingApprovals && data.totalPendingCount > 0) {
              this.pendingApprovalsData = data;
              this.isChannelPartner = !!data.isChannelPartner;
              this.showPendingApprovalsToast = true;
              this.changeDetectorRef.detectChanges();
            }
            else {
              this.showPendingApprovalsToast = false;
            }
          }
        },
        error => {
          this.pendingApprovalsRequestInFlight = false;
          console.error("Error fetching pending tariff approvals count:", error);
        },
        () => {
          this.pendingApprovalsRequestInFlight = false;
        }
      );
  }

  private async loadOrganisationTariffsLabel(): Promise<void> {
    try {
      const companyName = await this.secureStorage.getItem('companyName');
      if (companyName && typeof companyName === 'string' && companyName.trim() && companyName !== 'null') {
        this.organisationTariffsLabel = `${companyName.trim()} Tariffs`;
      } else {
        this.organisationTariffsLabel = 'Account Tariffs';
      }
    } catch (e) {
      this.organisationTariffsLabel = 'Account Tariffs';
    }
    this.changeDetectorRef.detectChanges();
  }

  skipTariffReview() {
    this.isSkippingTariffReview = true;
    const userIdStr = localStorage.getItem("userID");
    const body = {
      payload: {
        userID: userIdStr ? parseInt(userIdStr, 10) : 0,
        description: "User skipped pending tariff review for now."
      }
    };
    this.apiRequest.apiRequest("tariffs/skip_tariff_period_review", "skip_tariff_period_review.json", body, { cancelable: false })
      .subscribe(
        res => {
          this.isSkippingTariffReview = false;
          this.dismissPendingApprovals();
        },
        error => {
          this.isSkippingTariffReview = false;
          console.error("Error skipping tariff review:", error);
          this.dismissPendingApprovals();
        }
      );
  }

  dismissPendingApprovals() {
    const userId = localStorage.getItem('userID');
    if (userId) {
      sessionStorage.setItem(this.pendingApprovalsDismissedKey(userId), 'true');
    }
    this.showPendingApprovalsToast = false;
    this.changeDetectorRef.detectChanges();
  }

  reviewGlobalRates() {
    this.dismissPendingApprovals();
    localStorage.setItem("active", "tariff");
    this.router.navigate(['/dashboard/tariff/myTariff'], { queryParams: { status: 'new_rates_pending_approval' } });
  }

  reviewClientRates() {
    this.dismissPendingApprovals();
    localStorage.setItem("active", "tariff");
    this.router.navigate(['/dashboard/tariff/customTariff'], { queryParams: { status: 'new_rates_pending_approval' } });
  }

}
